"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5855],{

/***/ 89744:
/***/ (function(__unused_webpack_module, exports) {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.GELATO_STOP_LIMIT_ORDERS_MODULE_ADDRESS = exports.GENERIC_GAS_LIMIT_ORDER_EXECUTION = exports.NATIVE_WRAPPED_TOKEN_ADDRESS = exports.NATIVE_TOKEN_NAME = exports.NATIVE_WRAPPED_TOKEN_TICKER = exports.NATIVE_TOKEN_TICKER = exports.GELATO_LIMIT_ORDERS_ERC20_ORDER_ROUTER = exports.GELATO_LIMIT_ORDERS_MODULE_FLASHBOTS_ADDRESS = exports.GELATO_LIMIT_ORDERS_MODULE_ADDRESS = exports.GELATO_LIMIT_ORDERS_ADDRESS = exports.SUBGRAPH_URL = exports.OLD_SUBGRAPH_URL = exports.NETWORK_STOP_LIMIT_HANDLERS = exports.NETWORK_HANDLERS = exports.NETWORK_NAME = exports.HANDLERS_ADDRESSES = exports.LIMIT_ORDER_SLIPPAGE = exports.STOP_LIMIT_SLIPPAGE_BPS = exports.BPS_GELATO_FEE = exports.CHAIN_ID = exports.MAX_LIFETIME_IN_SECONDS = exports.SLIPPAGE_BPS = exports.ETH_ADDRESS = void 0;
exports.ETH_ADDRESS = "0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE";
exports.SLIPPAGE_BPS = 40; // 0.4%
exports.MAX_LIFETIME_IN_SECONDS = 7889238; // 3 months in seconds
exports.CHAIN_ID = {
    MAINNET: 1,
    ROPSTEN: 3,
    GOERLI: 5,
    CRONOS: 25,
    BSC: 56,
    MATIC: 137,
    FANTOM: 250,
    AVAX: 43114,
};
exports.BPS_GELATO_FEE = {
    [exports.CHAIN_ID.MAINNET]: 10,
    [exports.CHAIN_ID.MATIC]: 10,
    [exports.CHAIN_ID.FANTOM]: 10,
    [exports.CHAIN_ID.BSC]: 10,
    [exports.CHAIN_ID.AVAX]: 10,
    [exports.CHAIN_ID.CRONOS]: 10,
};
exports.STOP_LIMIT_SLIPPAGE_BPS = {
    [exports.CHAIN_ID.MAINNET]: 500,
    [exports.CHAIN_ID.ROPSTEN]: 500,
    [exports.CHAIN_ID.MATIC]: 500,
    [exports.CHAIN_ID.FANTOM]: 500,
    [exports.CHAIN_ID.BSC]: 500,
    [exports.CHAIN_ID.AVAX]: 500,
    [exports.CHAIN_ID.CRONOS]: 500,
};
exports.LIMIT_ORDER_SLIPPAGE = {
    [exports.CHAIN_ID.MAINNET]: 40,
    [exports.CHAIN_ID.ROPSTEN]: 40,
    [exports.CHAIN_ID.MATIC]: 40,
    [exports.CHAIN_ID.FANTOM]: 40,
    [exports.CHAIN_ID.BSC]: 40,
    [exports.CHAIN_ID.AVAX]: 40,
    [exports.CHAIN_ID.CRONOS]: 40,
};
exports.HANDLERS_ADDRESSES = {
    // UniswapV2Router02Handler
    [exports.CHAIN_ID.MAINNET]: {
        ["uniswap"]: "0x837c03414fb86861f28ca7e91e5fd770fda0f52d",
        ["uniswap_stoplimit"]: "0xf437a1a98566872f734bd18addf4bb610d1f887b",
    },
    // UniswapV2Router02Handler
    [exports.CHAIN_ID.ROPSTEN]: {
        ["uniswap"]: "0x1f397f95d31eb20183b69d685a5060cfdefd508b",
        ["quickswap_stoplimit"]: "0x87bE4Eb9dFb2DefcEA035D3010f33584Fc8ddDB5",
    },
    // UniswapV2Router02Handler
    [exports.CHAIN_ID.MATIC]: {
        ["quickswap"]: "0xaccbd2c6ad75ad3394dc5f4b1f606bf111e4eae3",
        ["polydex"]: "0x00fc86d360162e4672ec6B427E12ed36F39f1f53",
        ["cafeswap"]: "0xd167afcee4e9a89e69646fd3c27e58b61d1b7f97",
        ["mmfinance"]: "0xfbc6b53fa3792a95f37ac8d66e5110f41da0d976",
        ["quickswap_stoplimit"]: "0x51cc226648f8de65513de7cdfd3e7b116156234e",
    },
    // UniswapV2Router02Handler
    [exports.CHAIN_ID.FANTOM]: {
        ["spiritswap"]: "0x5fb00386558ccc219e51b69d8e963ef20b0c267a",
        ["spookyswap"]: "0x228ffd7122d202c0cd24330892881c47b0817c7a",
        ["bombswap"]: "0x87C4Fbd67f6DD8a1B5EFD9879956c728C97afeFe",
        ["defyswap"]: "0x3d401587320522a5e0bb973d10a852430a8edbbd",
        ["tombswap"]: "0xc72ef1bae14d0be7ec28c149e5e24659115f7c90",
        ["protofi"]: "0xfd2c20e265c130dc01d5cacc3012d3205e49c8b5",
        ["spiritswap_stoplimit"]: "0x6ea82c72732389c5149326e048a46be9f8bec8e8",
        ["spookyswap_stoplimit"]: "0xe912cd26c4a4cfffc175a297f1328ab23313a1a7",
    },
    // UniswapV2Router02Handler
    [exports.CHAIN_ID.BSC]: {
        ["pancakeswap"]: "0x88f8CCC064bA2D39cF08D57B6e7504a7B6bE8E4e",
        ["pancakeswap_stoplimit"]: "0x84b826bcd26f1bc0cd5fbbdef7f5b8965d6bbb38",
    },
    // UniswapV2Router02Handler
    [exports.CHAIN_ID.AVAX]: {
        ["traderjoe"]: "0x88f8CCC064bA2D39cF08D57B6e7504a7B6bE8E4e",
        ["pangolin"]: "0x8b206547cfe6f35a77ddab2d6d97260765a349ef",
        ["pangolin_stoplimit"]: "0xb4c53e2e32caf977d61a8a776bdc44837a5d0d91",
        ["traderjoe_stoplimit"]: "0xcf497830e43836738bdd0c3d7e09b599ddf081b2",
    },
    [exports.CHAIN_ID.CRONOS]: {
        ["vvsfinance"]: "0x6b9da2978ebe1c60d2cdaf52ee6c498cd8bb3f16",
        ["mmfinance"]: "0xee5154b3408e762d935f79ddef3a4ba56ac4d102",
    },
};
exports.NETWORK_NAME = {
    [exports.CHAIN_ID.MAINNET]: "Ethereum",
    [exports.CHAIN_ID.ROPSTEN]: "Ropsten",
    [exports.CHAIN_ID.GOERLI]: "Goerli",
    [exports.CHAIN_ID.MATIC]: "Polygon (Matic)",
    [exports.CHAIN_ID.FANTOM]: "FANTOM",
    [exports.CHAIN_ID.BSC]: "BSC",
    [exports.CHAIN_ID.AVAX]: "AVAX",
    [exports.CHAIN_ID.CRONOS]: "Cronos",
};
exports.NETWORK_HANDLERS = {
    [exports.CHAIN_ID.MAINNET]: ["uniswap", "uniswap_stoplimit"],
    [exports.CHAIN_ID.ROPSTEN]: ["uniswap", "quickswap_stoplimit"],
    [exports.CHAIN_ID.MATIC]: [
        "quickswap",
        "polydex",
        "cafeswap",
        "mmfinance",
        "quickswap_stoplimit",
    ],
    [exports.CHAIN_ID.FANTOM]: [
        "spiritswap",
        "spookyswap",
        "bombswap",
        "defyswap",
        "tombswap",
        "protofi",
        "spiritswap_stoplimit",
        "spookyswap_stoplimit",
    ],
    [exports.CHAIN_ID.BSC]: ["pancakeswap", "pancakeswap_stoplimit"],
    [exports.CHAIN_ID.AVAX]: [
        "traderjoe",
        "pangolin",
        "pangolin_stoplimit",
        "traderjoe_stoplimit",
    ],
    [exports.CHAIN_ID.CRONOS]: ["vvsfinance", "mmfinance"],
};
exports.NETWORK_STOP_LIMIT_HANDLERS = {
    [exports.CHAIN_ID.MAINNET]: ["uniswap_stoplimit"],
    [exports.CHAIN_ID.ROPSTEN]: ["quickswap_stoplimit"],
    [exports.CHAIN_ID.MATIC]: ["quickswap_stoplimit"],
    [exports.CHAIN_ID.BSC]: ["pancakeswap_stoplimit"],
    [exports.CHAIN_ID.FANTOM]: ["spookyswap_stoplimit", "spiritswap_stoplimit"],
    [exports.CHAIN_ID.AVAX]: ["traderjoe_stoplimit", "pangolin_stoplimit"],
};
exports.OLD_SUBGRAPH_URL = {
    [exports.CHAIN_ID.MAINNET]: "https://api.thegraph.com/subgraphs/name/gelatodigital/limit-orders",
    [exports.CHAIN_ID.ROPSTEN]: "https://api.thegraph.com/subgraphs/name/gelatodigital/limit-orders-ropsten",
    [exports.CHAIN_ID.MATIC]: "https://api.thegraph.com/subgraphs/name/gelatodigital/limit-orders-polygon",
    [exports.CHAIN_ID.FANTOM]: "https://api.thegraph.com/subgraphs/name/gelatodigital/limit-orders-fantom",
};
exports.SUBGRAPH_URL = {
    [exports.CHAIN_ID.MAINNET]: "https://api.thegraph.com/subgraphs/name/gelatodigital/limit-orders-ii",
    [exports.CHAIN_ID.MATIC]: "https://api.thegraph.com/subgraphs/name/gelatodigital/limit-orders-polygon-ii",
    [exports.CHAIN_ID.FANTOM]: "https://api.thegraph.com/subgraphs/name/gelatodigital/limit-orders-fantom-ii",
    [exports.CHAIN_ID.BSC]: "https://api.thegraph.com/subgraphs/name/gelatodigital/limit-orders-bsc",
    [exports.CHAIN_ID.AVAX]: "https://api.thegraph.com/subgraphs/name/gelatodigital/limit-orders-avax",
    [exports.CHAIN_ID.CRONOS]: "https://graph.cronoslabs.com/subgraphs/name/gelatonetwork/limit-orders-cronos",
};
exports.GELATO_LIMIT_ORDERS_ADDRESS = {
    [exports.CHAIN_ID.MAINNET]: "0x36049D479A97CdE1fC6E2a5D2caE30B666Ebf92B",
    [exports.CHAIN_ID.ROPSTEN]: "0x0e5096D201Fe2985f5C26432A76f145D6e5D1453",
    [exports.CHAIN_ID.GOERLI]: "0xa0453c6ab71fe3da89640ee2503326bd0899a589",
    [exports.CHAIN_ID.MATIC]: "0x38c4092b28dAB7F3d98eE6524549571c283cdfA5",
    [exports.CHAIN_ID.FANTOM]: "0x05Ad1094Eb6Cde564d732196F6754Ee464896031",
    [exports.CHAIN_ID.BSC]: "0x0c30D3d66bc7C73A83fdA929888c34dcb24FD599",
    [exports.CHAIN_ID.AVAX]: "0x0c30D3d66bc7C73A83fdA929888c34dcb24FD599",
    [exports.CHAIN_ID.CRONOS]: "0x5d41545c190637b9337ec5ffa89bac5ee0cb3a4c",
};
exports.GELATO_LIMIT_ORDERS_MODULE_ADDRESS = {
    [exports.CHAIN_ID.MAINNET]: "0x037fc8e71445910e1E0bBb2a0896d5e9A7485318",
    [exports.CHAIN_ID.ROPSTEN]: "0x3f3C13b09B601fb6074124fF8D779d2964caBf8B",
    [exports.CHAIN_ID.GOERLI]: "0xCf8EDB3333Fae73b23f689229F4De6Ac95d1f707",
    [exports.CHAIN_ID.MATIC]: "0x5A36178E38864F5E724A2DaF5f9cD9bA473f7903",
    [exports.CHAIN_ID.FANTOM]: "0xf2253BF9a0BD002300cFe6f4E630d755669f6DCa",
    [exports.CHAIN_ID.BSC]: "0xb7499a92fc36e9053a4324aFfae59d333635D9c3",
    [exports.CHAIN_ID.AVAX]: "0xb7499a92fc36e9053a4324aFfae59d333635D9c3",
    [exports.CHAIN_ID.CRONOS]: "0xf437a1a98566872f734BD18aDdF4BB610D1F887b",
};
exports.GELATO_LIMIT_ORDERS_MODULE_FLASHBOTS_ADDRESS = {
    [exports.CHAIN_ID.MAINNET]: "0xbeC333EDE1A0687D2b9624F8C073a54c93ba9777",
    [exports.CHAIN_ID.GOERLI]: "0xCf8EDB3333Fae73b23f689229F4De6Ac95d1f707",
};
exports.GELATO_LIMIT_ORDERS_ERC20_ORDER_ROUTER = {
    [exports.CHAIN_ID.MAINNET]: "0x5fb00386558ccc219e51b69d8e963ef20b0c267a",
    [exports.CHAIN_ID.ROPSTEN]: "0x9c06ff386779cc2269d482bcecf2378a4ff5cb90",
    [exports.CHAIN_ID.GOERLI]: "0x247A1306b6122ba28862b19a95004899db91f1b5",
    [exports.CHAIN_ID.MATIC]: "0x16773FcA1bd726E1eafAB52699bcF738fE4AdF69",
    [exports.CHAIN_ID.FANTOM]: "0x97C1af451407e266fD57168e61D4B5af31894244",
    [exports.CHAIN_ID.BSC]: "0x64c7f3c2C19B41a6aD67bb5f4edc8EdbB3284F34",
    [exports.CHAIN_ID.AVAX]: "0x3441456d5750f4a22b0DcBD434D99B97455B70Ac",
    [exports.CHAIN_ID.CRONOS]: "0x260aB0aCb931D7Da784fC35c7E96c3B13213Abf1",
};
exports.NATIVE_TOKEN_TICKER = {
    [exports.CHAIN_ID.MAINNET]: "ETH",
    [exports.CHAIN_ID.ROPSTEN]: "ETH",
    [exports.CHAIN_ID.GOERLI]: "ETH",
    [exports.CHAIN_ID.MATIC]: "MATIC",
    [exports.CHAIN_ID.FANTOM]: "FTM",
    [exports.CHAIN_ID.BSC]: "BNB",
    [exports.CHAIN_ID.AVAX]: "AVAX",
    [exports.CHAIN_ID.CRONOS]: "CRO",
};
exports.NATIVE_WRAPPED_TOKEN_TICKER = {
    [exports.CHAIN_ID.MAINNET]: "WETH",
    [exports.CHAIN_ID.ROPSTEN]: "WETH",
    [exports.CHAIN_ID.GOERLI]: "WETH",
    [exports.CHAIN_ID.MATIC]: "WMATIC",
    [exports.CHAIN_ID.FANTOM]: "WFTM",
    [exports.CHAIN_ID.BSC]: "WBNB",
    [exports.CHAIN_ID.AVAX]: "WAVAX",
    [exports.CHAIN_ID.CRONOS]: "WCRO",
};
exports.NATIVE_TOKEN_NAME = {
    [exports.CHAIN_ID.MAINNET]: "Ether",
    [exports.CHAIN_ID.ROPSTEN]: "Ether",
    [exports.CHAIN_ID.GOERLI]: "Ether",
    [exports.CHAIN_ID.MATIC]: "Matic",
    [exports.CHAIN_ID.FANTOM]: "Fantom",
    [exports.CHAIN_ID.BSC]: "Bnb",
    [exports.CHAIN_ID.AVAX]: "Avax",
    [exports.CHAIN_ID.CRONOS]: "Cronos",
};
exports.NATIVE_WRAPPED_TOKEN_ADDRESS = {
    [exports.CHAIN_ID.MAINNET]: "0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2",
    [exports.CHAIN_ID.ROPSTEN]: "0xc778417e063141139fce010982780140aa0cd5ab",
    [exports.CHAIN_ID.GOERLI]: "0xB4FBF271143F4FBf7B91A5ded31805e42b2208d6",
    [exports.CHAIN_ID.MATIC]: "0x0d500B1d8E8eF31E21C99d1Db9A6444d3ADf1270",
    [exports.CHAIN_ID.FANTOM]: "0x21be370d5312f44cb42ce377bc9b8a0cef1a4c83",
    [exports.CHAIN_ID.BSC]: "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c",
    [exports.CHAIN_ID.AVAX]: "0xB31f66AA3C1e785363F0875A1B74E27b85FD66c7",
    [exports.CHAIN_ID.CRONOS]: "0x5C7F8A570d578ED84E63fdFA7b1eE72dEae1AE23",
};
exports.GENERIC_GAS_LIMIT_ORDER_EXECUTION = "400000";
exports.GELATO_STOP_LIMIT_ORDERS_MODULE_ADDRESS = {
    [exports.CHAIN_ID.MAINNET]: "0x260aB0aCb931D7Da784fC35c7E96c3B13213Abf1",
    [exports.CHAIN_ID.ROPSTEN]: "0xDC41072F4aFE7e4a7ea0f21d13a92662Fe733C55",
    [exports.CHAIN_ID.MATIC]: "0x81967ac4ce8e2d94f7e4b4cf3d2e760605079604",
    [exports.CHAIN_ID.BSC]: "0xe912cd26c4a4cfffc175a297f1328ab23313a1a7",
    [exports.CHAIN_ID.FANTOM]: "0xf437a1a98566872f734bd18addf4bb610d1f887b",
    [exports.CHAIN_ID.AVAX]: "0xf437a1a98566872f734bd18addf4bb610d1f887b",
    [exports.CHAIN_ID.CRONOS]: "",
};


/***/ }),

/***/ 98081:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ERC20OrderRouter__factory = void 0;
const ethers_1 = __webpack_require__(4730);
const _abi = [
    {
        inputs: [
            {
                internalType: "contract IGelatoPineCore",
                name: "_gelatoPineCore",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "key",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "address",
                name: "caller",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "address",
                name: "module",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "inputToken",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "witness",
                type: "address",
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "secret",
                type: "bytes32",
            },
        ],
        name: "DepositToken",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_amount",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "_module",
                type: "address",
            },
            {
                internalType: "address",
                name: "_inputToken",
                type: "address",
            },
            {
                internalType: "address payable",
                name: "_owner",
                type: "address",
            },
            {
                internalType: "address",
                name: "_witness",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "_data",
                type: "bytes",
            },
            {
                internalType: "bytes32",
                name: "_secret",
                type: "bytes32",
            },
        ],
        name: "depositToken",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "gelatoPineCore",
        outputs: [
            {
                internalType: "contract IGelatoPineCore",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
class ERC20OrderRouter__factory {
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.ERC20OrderRouter__factory = ERC20OrderRouter__factory;
ERC20OrderRouter__factory.abi = _abi;


/***/ }),

/***/ 99272:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ERC20__factory = void 0;
const ethers_1 = __webpack_require__(4730);
const _abi = [
    {
        constant: true,
        inputs: [],
        name: "name",
        outputs: [
            {
                name: "",
                type: "string",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                name: "_spender",
                type: "address",
            },
            {
                name: "_value",
                type: "uint256",
            },
        ],
        name: "approve",
        outputs: [
            {
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "totalSupply",
        outputs: [
            {
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                name: "_from",
                type: "address",
            },
            {
                name: "_to",
                type: "address",
            },
            {
                name: "_value",
                type: "uint256",
            },
        ],
        name: "transferFrom",
        outputs: [
            {
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "decimals",
        outputs: [
            {
                name: "",
                type: "uint8",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                name: "_owner",
                type: "address",
            },
        ],
        name: "balanceOf",
        outputs: [
            {
                name: "balance",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "symbol",
        outputs: [
            {
                name: "",
                type: "string",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                name: "_to",
                type: "address",
            },
            {
                name: "_value",
                type: "uint256",
            },
        ],
        name: "transfer",
        outputs: [
            {
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                name: "_owner",
                type: "address",
            },
            {
                name: "_spender",
                type: "address",
            },
        ],
        name: "allowance",
        outputs: [
            {
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        payable: true,
        stateMutability: "payable",
        type: "fallback",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                name: "owner",
                type: "address",
            },
            {
                indexed: true,
                name: "spender",
                type: "address",
            },
            {
                indexed: false,
                name: "value",
                type: "uint256",
            },
        ],
        name: "Approval",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                name: "from",
                type: "address",
            },
            {
                indexed: true,
                name: "to",
                type: "address",
            },
            {
                indexed: false,
                name: "value",
                type: "uint256",
            },
        ],
        name: "Transfer",
        type: "event",
    },
];
class ERC20__factory {
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.ERC20__factory = ERC20__factory;
ERC20__factory.abi = _abi;


/***/ }),

/***/ 23744:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.GelatoLimitOrders__factory = void 0;
const ethers_1 = __webpack_require__(4730);
const _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "_key",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "address",
                name: "_caller",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "_amount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "_data",
                type: "bytes",
            },
        ],
        name: "DepositETH",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "_key",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "address",
                name: "_inputToken",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "_owner",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "_witness",
                type: "address",
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "_data",
                type: "bytes",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "_amount",
                type: "uint256",
            },
        ],
        name: "OrderCancelled",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "_key",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "address",
                name: "_inputToken",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "_owner",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "_witness",
                type: "address",
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "_data",
                type: "bytes",
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "_auxData",
                type: "bytes",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "_amount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "_bought",
                type: "uint256",
            },
        ],
        name: "OrderExecuted",
        type: "event",
    },
    {
        inputs: [],
        name: "ETH_ADDRESS",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract IModule",
                name: "_module",
                type: "address",
            },
            {
                internalType: "contract IERC20",
                name: "_inputToken",
                type: "address",
            },
            {
                internalType: "address payable",
                name: "_owner",
                type: "address",
            },
            {
                internalType: "address",
                name: "_witness",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "_data",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "_auxData",
                type: "bytes",
            },
        ],
        name: "canExecuteOrder",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract IModule",
                name: "_module",
                type: "address",
            },
            {
                internalType: "contract IERC20",
                name: "_inputToken",
                type: "address",
            },
            {
                internalType: "address payable",
                name: "_owner",
                type: "address",
            },
            {
                internalType: "address",
                name: "_witness",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "_data",
                type: "bytes",
            },
        ],
        name: "cancelOrder",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "_data",
                type: "bytes",
            },
        ],
        name: "decodeOrder",
        outputs: [
            {
                internalType: "address",
                name: "module",
                type: "address",
            },
            {
                internalType: "address",
                name: "inputToken",
                type: "address",
            },
            {
                internalType: "address payable",
                name: "owner",
                type: "address",
            },
            {
                internalType: "address",
                name: "witness",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
            {
                internalType: "bytes32",
                name: "secret",
                type: "bytes32",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "_data",
                type: "bytes",
            },
        ],
        name: "depositEth",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_module",
                type: "address",
            },
            {
                internalType: "address",
                name: "_inputToken",
                type: "address",
            },
            {
                internalType: "address payable",
                name: "_owner",
                type: "address",
            },
            {
                internalType: "address",
                name: "_witness",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "_data",
                type: "bytes",
            },
            {
                internalType: "bytes32",
                name: "_secret",
                type: "bytes32",
            },
        ],
        name: "encodeEthOrder",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract IModule",
                name: "_module",
                type: "address",
            },
            {
                internalType: "contract IERC20",
                name: "_inputToken",
                type: "address",
            },
            {
                internalType: "address payable",
                name: "_owner",
                type: "address",
            },
            {
                internalType: "address",
                name: "_witness",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "_data",
                type: "bytes",
            },
            {
                internalType: "bytes32",
                name: "_secret",
                type: "bytes32",
            },
            {
                internalType: "uint256",
                name: "_amount",
                type: "uint256",
            },
        ],
        name: "encodeTokenOrder",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        name: "ethDeposits",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract IModule",
                name: "_module",
                type: "address",
            },
            {
                internalType: "contract IERC20",
                name: "_inputToken",
                type: "address",
            },
            {
                internalType: "address payable",
                name: "_owner",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "_data",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "_signature",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "_auxData",
                type: "bytes",
            },
        ],
        name: "executeOrder",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract IModule",
                name: "_module",
                type: "address",
            },
            {
                internalType: "contract IERC20",
                name: "_inputToken",
                type: "address",
            },
            {
                internalType: "address payable",
                name: "_owner",
                type: "address",
            },
            {
                internalType: "address",
                name: "_witness",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "_data",
                type: "bytes",
            },
        ],
        name: "existOrder",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract IModule",
                name: "_module",
                type: "address",
            },
            {
                internalType: "contract IERC20",
                name: "_inputToken",
                type: "address",
            },
            {
                internalType: "address payable",
                name: "_owner",
                type: "address",
            },
            {
                internalType: "address",
                name: "_witness",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "_data",
                type: "bytes",
            },
        ],
        name: "keyOf",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract IModule",
                name: "_module",
                type: "address",
            },
            {
                internalType: "contract IERC20",
                name: "_inputToken",
                type: "address",
            },
            {
                internalType: "address payable",
                name: "_owner",
                type: "address",
            },
            {
                internalType: "address",
                name: "_witness",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "_data",
                type: "bytes",
            },
        ],
        name: "vaultOfOrder",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        stateMutability: "payable",
        type: "receive",
    },
];
class GelatoLimitOrders__factory {
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.GelatoLimitOrders__factory = GelatoLimitOrders__factory;
GelatoLimitOrders__factory.abi = _abi;


/***/ }),

/***/ 82354:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Multicall__factory = void 0;
const ethers_1 = __webpack_require__(4730);
const _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "_factory",
                type: "address",
            },
            {
                internalType: "address",
                name: "_mainModule",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "_wallet",
                type: "address",
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "_imageHash",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "_threshold",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "_signers",
                type: "bytes",
            },
        ],
        name: "RequiredConfig",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "_wallet",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "_signer",
                type: "address",
            },
        ],
        name: "RequiredSigner",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_addr",
                type: "address",
            },
        ],
        name: "callBalanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "callBlockNumber",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_i",
                type: "uint256",
            },
        ],
        name: "callBlockhash",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "callChainId",
        outputs: [
            {
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_addr",
                type: "address",
            },
        ],
        name: "callCode",
        outputs: [
            {
                internalType: "bytes",
                name: "code",
                type: "bytes",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_addr",
                type: "address",
            },
        ],
        name: "callCodeHash",
        outputs: [
            {
                internalType: "bytes32",
                name: "codeHash",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_addr",
                type: "address",
            },
        ],
        name: "callCodeSize",
        outputs: [
            {
                internalType: "uint256",
                name: "size",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "callCoinbase",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "callDifficulty",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "callGasLeft",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "callGasLimit",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "callGasPrice",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "callOrigin",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "callTimestamp",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "lastSignerUpdate",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "lastWalletUpdate",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "bool",
                        name: "delegateCall",
                        type: "bool",
                    },
                    {
                        internalType: "bool",
                        name: "revertOnError",
                        type: "bool",
                    },
                    {
                        internalType: "uint256",
                        name: "gasLimit",
                        type: "uint256",
                    },
                    {
                        internalType: "address",
                        name: "target",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "value",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes",
                        name: "data",
                        type: "bytes",
                    },
                ],
                internalType: "struct IModuleCalls.Transaction[]",
                name: "_txs",
                type: "tuple[]",
            },
        ],
        name: "multiCall",
        outputs: [
            {
                internalType: "bool[]",
                name: "_successes",
                type: "bool[]",
            },
            {
                internalType: "bytes[]",
                name: "_results",
                type: "bytes[]",
            },
        ],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_wallet",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_threshold",
                type: "uint256",
            },
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "weight",
                        type: "uint256",
                    },
                    {
                        internalType: "address",
                        name: "signer",
                        type: "address",
                    },
                ],
                internalType: "struct RequireUtils.Member[]",
                name: "_members",
                type: "tuple[]",
            },
            {
                internalType: "bool",
                name: "_index",
                type: "bool",
            },
        ],
        name: "publishConfig",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_wallet",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "_hash",
                type: "bytes32",
            },
            {
                internalType: "uint256",
                name: "_sizeMembers",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "_signature",
                type: "bytes",
            },
            {
                internalType: "bool",
                name: "_index",
                type: "bool",
            },
        ],
        name: "publishInitialSigners",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_wallet",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_nonce",
                type: "uint256",
            },
        ],
        name: "requireMinNonce",
        outputs: [],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_expiration",
                type: "uint256",
            },
        ],
        name: "requireNonExpired",
        outputs: [],
        stateMutability: "view",
        type: "function",
    },
];
class Multicall__factory {
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.Multicall__factory = Multicall__factory;
Multicall__factory.abi = _abi;


/***/ }),

/***/ 16060:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Multicall__factory = exports.GelatoLimitOrders__factory = exports.ERC20OrderRouter__factory = exports.ERC20__factory = void 0;
var ERC20__factory_1 = __webpack_require__(99272);
Object.defineProperty(exports, "ERC20__factory", ({ enumerable: true, get: function () { return ERC20__factory_1.ERC20__factory; } }));
var ERC20OrderRouter__factory_1 = __webpack_require__(98081);
Object.defineProperty(exports, "ERC20OrderRouter__factory", ({ enumerable: true, get: function () { return ERC20OrderRouter__factory_1.ERC20OrderRouter__factory; } }));
var GelatoLimitOrders__factory_1 = __webpack_require__(23744);
Object.defineProperty(exports, "GelatoLimitOrders__factory", ({ enumerable: true, get: function () { return GelatoLimitOrders__factory_1.GelatoLimitOrders__factory; } }));
var Multicall__factory_1 = __webpack_require__(82354);
Object.defineProperty(exports, "Multicall__factory", ({ enumerable: true, get: function () { return Multicall__factory_1.Multicall__factory; } }));


/***/ }),

/***/ 55855:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.constants = exports.utils = exports.isEthereumChain = exports.GelatoStopLimitOrders = exports.isValidChainIdAndHandler = exports.GelatoLimitOrders = void 0;
const tslib_1 = __webpack_require__(97582);
var limit_orders_1 = __webpack_require__(78905);
Object.defineProperty(exports, "GelatoLimitOrders", ({ enumerable: true, get: function () { return limit_orders_1.GelatoLimitOrders; } }));
Object.defineProperty(exports, "isValidChainIdAndHandler", ({ enumerable: true, get: function () { return limit_orders_1.isValidChainIdAndHandler; } }));
var stoplimit_orders_1 = __webpack_require__(45741);
Object.defineProperty(exports, "GelatoStopLimitOrders", ({ enumerable: true, get: function () { return stoplimit_orders_1.GelatoStopLimitOrders; } }));
var utils_1 = __webpack_require__(41153);
Object.defineProperty(exports, "isEthereumChain", ({ enumerable: true, get: function () { return utils_1.isEthereumChain; } }));
tslib_1.__exportStar(__webpack_require__(82938), exports);
exports.utils = tslib_1.__importStar(__webpack_require__(41153));
exports.constants = tslib_1.__importStar(__webpack_require__(89744));


/***/ }),

/***/ 78905:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.GelatoLimitOrders = exports.isFlashbotsCompatibleChainId = exports.isValidChainIdAndHandler = void 0;
const tslib_1 = __webpack_require__(97582);
const ethers_1 = __webpack_require__(4730);
const abstract_provider_1 = __webpack_require__(81556);
const abstract_signer_1 = __webpack_require__(48088);
const constants_1 = __webpack_require__(89744);
const types_1 = __webpack_require__(16060);
const queries_1 = __webpack_require__(40615);
const utils_1 = __webpack_require__(41153);
const isValidChainIdAndHandler = (chainId, handler) => {
    return constants_1.NETWORK_HANDLERS[chainId].includes(handler);
};
exports.isValidChainIdAndHandler = isValidChainIdAndHandler;
const isFlashbotsCompatibleChainId = (chainId) => {
    return chainId == constants_1.CHAIN_ID.MAINNET || chainId == constants_1.CHAIN_ID.GOERLI;
};
exports.isFlashbotsCompatibleChainId = isFlashbotsCompatibleChainId;
class GelatoLimitOrders {
    constructor(chainId, signerOrProvider, handler, isFlashbotsProtected = false, subgraphUrl) {
        var _a;
        if (handler && !(0, exports.isValidChainIdAndHandler)(chainId, handler)) {
            throw new Error("Invalid chainId and handler");
        }
        else if (isFlashbotsProtected &&
            (handler || !(0, exports.isFlashbotsCompatibleChainId)(chainId))) {
            throw new Error("Invalid chainId or handler for Flashbots bundle submission. handler must be undefined, and chainId either 1 (mainnet) or 5 (goerli)");
        }
        this._chainId = chainId;
        this._gelatoFeeBPS = constants_1.BPS_GELATO_FEE[chainId];
        this._slippageBPS = constants_1.LIMIT_ORDER_SLIPPAGE[chainId];
        this._subgraphUrl = subgraphUrl !== null && subgraphUrl !== void 0 ? subgraphUrl : constants_1.SUBGRAPH_URL[chainId];
        this._signer = abstract_signer_1.Signer.isSigner(signerOrProvider)
            ? signerOrProvider
            : undefined;
        this._provider = abstract_provider_1.Provider.isProvider(signerOrProvider)
            ? signerOrProvider
            : abstract_signer_1.Signer.isSigner(signerOrProvider)
                ? signerOrProvider.provider
                : undefined;
        this._gelatoLimitOrders = this._signer
            ? types_1.GelatoLimitOrders__factory.connect(constants_1.GELATO_LIMIT_ORDERS_ADDRESS[this._chainId], this._signer)
            : this._provider
                ? types_1.GelatoLimitOrders__factory.connect(constants_1.GELATO_LIMIT_ORDERS_ADDRESS[this._chainId], this._provider)
                : new ethers_1.Contract(constants_1.GELATO_LIMIT_ORDERS_ADDRESS[this._chainId], types_1.GelatoLimitOrders__factory.createInterface());
        this._moduleAddress = isFlashbotsProtected
            ? constants_1.GELATO_LIMIT_ORDERS_MODULE_FLASHBOTS_ADDRESS[this._chainId]
            : constants_1.GELATO_LIMIT_ORDERS_MODULE_ADDRESS[this._chainId];
        this._handler = handler;
        this._handlerAddress = handler
            ? (_a = constants_1.HANDLERS_ADDRESSES[this._chainId][handler]) === null || _a === void 0 ? void 0 : _a.toLowerCase()
            : undefined;
        this._isFlashbotsProtected = isFlashbotsProtected;
        this._abiEncoder = new ethers_1.utils.AbiCoder();
        this._erc20OrderRouter = this._signer
            ? types_1.ERC20OrderRouter__factory.connect(constants_1.GELATO_LIMIT_ORDERS_ERC20_ORDER_ROUTER[this._chainId], this._signer)
            : this._provider
                ? types_1.ERC20OrderRouter__factory.connect(constants_1.GELATO_LIMIT_ORDERS_ERC20_ORDER_ROUTER[this._chainId], this._provider)
                : new ethers_1.Contract(constants_1.GELATO_LIMIT_ORDERS_ERC20_ORDER_ROUTER[this._chainId], types_1.ERC20OrderRouter__factory.createInterface());
    }
    get gelatoFeeBPS() {
        return this._gelatoFeeBPS;
    }
    get slippageBPS() {
        return this._slippageBPS;
    }
    get chainId() {
        return this._chainId;
    }
    get signer() {
        return this._signer;
    }
    get provider() {
        return this._provider;
    }
    get subgraphUrl() {
        return this._subgraphUrl;
    }
    set subgraphUrl(url) {
        this._subgraphUrl = url;
    }
    get handler() {
        return this._handler;
    }
    get handlerAddress() {
        return this._handlerAddress;
    }
    get moduleAddress() {
        return this._moduleAddress;
    }
    get contract() {
        return this._gelatoLimitOrders;
    }
    get erc20OrderRouter() {
        return this._erc20OrderRouter;
    }
    get isFlashbotsProtected() {
        return this._isFlashbotsProtected;
    }
    encodeLimitOrderSubmission(inputToken, outputToken, inputAmount, minReturn, owner, checkAllowance = true) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { payload } = yield this.encodeLimitOrderSubmissionWithSecret(inputToken, outputToken, inputAmount, minReturn, owner, checkAllowance);
            return payload;
        });
    }
    encodeLimitOrderSubmissionWithSecret(inputToken, outputToken, inputAmount, minReturnToBeParsed, owner, checkAllowance = true) {
        var _a;
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const randomSecret = ethers_1.utils.hexlify(ethers_1.utils.randomBytes(19)).replace("0x", "");
            // 0x67656c61746f6e6574776f726b = gelatonetwork in hex
            const fullSecret = `0x67656c61746f6e6574776f726b${randomSecret}`;
            const { privateKey: secret, address: witness } = new ethers_1.Wallet(fullSecret);
            const { minReturn } = this.getFeeAndSlippageAdjustedMinReturn(minReturnToBeParsed);
            const payload = yield this._encodeSubmitData(inputToken, outputToken, owner, witness, inputAmount, minReturn, secret, checkAllowance);
            const encodedData = this._handlerAddress
                ? this._abiEncoder.encode(["address", "uint256", "address"], [outputToken, minReturn, this._handlerAddress])
                : this._abiEncoder.encode(["address", "uint256"], [outputToken, minReturn]);
            return {
                payload,
                secret,
                witness,
                order: {
                    id: this._getKey({
                        module: this._moduleAddress,
                        inputToken,
                        owner,
                        witness,
                        data: encodedData,
                    }),
                    module: this._moduleAddress.toLowerCase(),
                    data: encodedData,
                    inputToken: inputToken.toLowerCase(),
                    outputToken: outputToken.toLowerCase(),
                    owner: owner.toLowerCase(),
                    witness: witness.toLowerCase(),
                    inputAmount: inputAmount.toString(),
                    minReturn: minReturn.toString(),
                    adjustedMinReturn: minReturnToBeParsed.toString(),
                    inputData: payload.data.toString(),
                    secret: secret.toLowerCase(),
                    handler: (_a = this._handlerAddress) !== null && _a !== void 0 ? _a : null,
                },
            };
        });
    }
    submitLimitOrder(inputToken, outputToken, inputAmount, minReturn, checkAllowance = true, overrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (!this._signer)
                throw new Error("No signer");
            const owner = yield this._signer.getAddress();
            const txData = yield this.encodeLimitOrderSubmission(inputToken, outputToken, inputAmount, minReturn, owner, checkAllowance);
            return this._signer.sendTransaction(Object.assign(Object.assign({}, overrides), { to: txData.to, data: txData.data, value: ethers_1.BigNumber.from(txData.value) }));
        });
    }
    encodeLimitOrderCancellation(order, checkIsActiveOrder) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (!this._gelatoLimitOrders)
                throw new Error("No gelato limit orders contract");
            if (!order.inputToken)
                throw new Error("No input token in order");
            if (!order.witness)
                throw new Error("No witness in order");
            if (!order.outputToken)
                throw new Error("No output token in order");
            if (!order.minReturn)
                throw new Error("No minReturn in order");
            if (!order.owner)
                throw new Error("No owner");
            if (!order.module)
                throw new Error("No module in order");
            if (checkIsActiveOrder) {
                const isActiveOrder = yield this.isActiveOrder(order);
                if (!isActiveOrder)
                    throw new Error("Order not found. Please review your order data.");
            }
            const data = this._gelatoLimitOrders.interface.encodeFunctionData("cancelOrder", [order.module, order.inputToken, order.owner, order.witness, order.data]);
            return {
                data,
                to: this._gelatoLimitOrders.address,
                value: ethers_1.constants.Zero,
            };
        });
    }
    cancelLimitOrder(order, checkIsActiveOrder, overrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (!this._signer)
                throw new Error("No signer");
            if (!this._gelatoLimitOrders)
                throw new Error("No gelato limit orders contract");
            let _order = order;
            if (order.id) {
                try {
                    const subgraphOrder = yield Promise.race([
                        this.getOrder(order.id),
                        new Promise((resolve) => setTimeout(resolve, 5000)).then(() => {
                            throw new Error("Timeout");
                        }),
                    ]);
                    if (subgraphOrder) {
                        if (subgraphOrder.status === "cancelled") {
                            throw new Error(`Order status is not open. Current order status: ${subgraphOrder.status}. Cancellation transaction hash: ${subgraphOrder.cancelledTxHash}`);
                        }
                        if (subgraphOrder.status === "executed") {
                            throw new Error(`Order status is not open. Current order status: ${subgraphOrder.status}. Execution transaction hash: ${subgraphOrder.executedTxHash}`);
                        }
                        _order = Object.assign(Object.assign({}, order), subgraphOrder);
                    }
                    // eslint-disable-next-line no-empty
                }
                catch (error) { }
            }
            if (!_order.inputToken)
                throw new Error("No input token in order");
            if (!_order.witness)
                throw new Error("No witness in order");
            if (!_order.outputToken)
                throw new Error("No output token in order");
            if (!_order.minReturn)
                throw new Error("No minReturn in order");
            if (!_order.data)
                throw new Error("No data in order");
            if (!_order.module)
                throw new Error("No module in order");
            if (checkIsActiveOrder) {
                const isActiveOrder = yield this.isActiveOrder(_order);
                if (!isActiveOrder)
                    throw new Error("Order not found. Please review your order data.");
            }
            const owner = yield this._signer.getAddress();
            if (owner.toLowerCase() !== order.owner.toLowerCase())
                throw new Error("Owner and signer mismatch");
            return this._gelatoLimitOrders.cancelOrder(_order.module, _order.inputToken, _order.owner, _order.witness, _order.data, overrides !== null && overrides !== void 0 ? overrides : {
                gasLimit: (0, utils_1.isEthereumChain)(this._chainId) ? 600000 : 2000000,
            });
        });
    }
    approveTokenAmount(inputToken, amount, overrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (!this._signer)
                throw new Error("No signer");
            return overrides
                ? types_1.ERC20__factory.connect(inputToken, this._signer).approve(this._erc20OrderRouter.address, amount, overrides)
                : types_1.ERC20__factory.connect(inputToken, this._signer).approve(this._erc20OrderRouter.address, amount);
        });
    }
    isActiveOrder(order) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (!this._provider)
                throw new Error("No provider");
            if (!this._gelatoLimitOrders)
                throw new Error("No gelato limit orders contract");
            if (!order.module)
                throw new Error("No module in order");
            if (!order.inputToken)
                throw new Error("No input token in order");
            if (!order.owner)
                throw new Error("No owner in order");
            if (!order.witness)
                throw new Error("No witness in order");
            if (!order.data)
                throw new Error("No data in order");
            return this._gelatoLimitOrders.existOrder(order.module, order.inputToken, order.owner, order.witness, order.data);
        });
    }
    getExchangeRate(inputValue, inputDecimals, outputValue, outputDecimals, invert = false) {
        const factor = ethers_1.BigNumber.from(10).pow(ethers_1.BigNumber.from(18));
        if (invert) {
            return ethers_1.BigNumber.from(inputValue)
                .mul(factor)
                .div(outputValue)
                .mul(ethers_1.BigNumber.from(10).pow(ethers_1.BigNumber.from(outputDecimals)))
                .div(ethers_1.BigNumber.from(10).pow(ethers_1.BigNumber.from(inputDecimals)))
                .toString();
        }
        else {
            return ethers_1.BigNumber.from(outputValue)
                .mul(factor)
                .div(inputValue)
                .mul(ethers_1.BigNumber.from(10).pow(ethers_1.BigNumber.from(inputDecimals)))
                .div(ethers_1.BigNumber.from(10).pow(ethers_1.BigNumber.from(outputDecimals)))
                .toString();
        }
    }
    getFeeAndSlippageAdjustedMinReturn(outputAmount, extraSlippageBPS) {
        if (extraSlippageBPS) {
            if (!Number.isInteger(extraSlippageBPS))
                throw new Error("Extra Slippage BPS must an unsigned integer");
        }
        const gelatoFee = ethers_1.BigNumber.from(outputAmount)
            .mul(this._gelatoFeeBPS)
            .div(10000)
            .gte(1)
            ? ethers_1.BigNumber.from(outputAmount).mul(this._gelatoFeeBPS).div(10000)
            : ethers_1.BigNumber.from(1);
        const slippageBPS = extraSlippageBPS
            ? this._slippageBPS + extraSlippageBPS
            : this._slippageBPS;
        const slippage = ethers_1.BigNumber.from(outputAmount).mul(slippageBPS).div(10000);
        const minReturn = ethers_1.BigNumber.from(outputAmount).sub(gelatoFee).sub(slippage);
        return {
            minReturn: minReturn.toString(),
            slippage: slippage.toString(),
            gelatoFee: gelatoFee.toString(),
        };
    }
    getAdjustedMinReturn(minReturn, extraSlippageBPS) {
        const gelatoFee = ethers_1.BigNumber.from(this._gelatoFeeBPS);
        const slippage = extraSlippageBPS
            ? ethers_1.BigNumber.from(this._slippageBPS + extraSlippageBPS)
            : ethers_1.BigNumber.from(this._slippageBPS);
        const fees = gelatoFee.add(slippage);
        const adjustedMinReturn = ethers_1.BigNumber.from(minReturn)
            .mul(10000)
            .div(ethers_1.BigNumber.from(10000).sub(fees));
        return adjustedMinReturn.toString();
    }
    getExecutionPrice(inputAmount, inputDecimals, outputAmount, outputDecimals, isInverted = false) {
        const factor = ethers_1.BigNumber.from(10).pow(ethers_1.BigNumber.from(isInverted ? outputDecimals : inputDecimals));
        if (isInverted) {
            return ethers_1.BigNumber.from(inputAmount)
                .mul(factor)
                .div(outputAmount)
                .toString();
        }
        else {
            return ethers_1.BigNumber.from(outputAmount)
                .mul(factor)
                .div(inputAmount)
                .toString();
        }
    }
    getOrder(orderId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const order = yield (0, queries_1.queryOrder)(orderId, this._chainId);
            if (order) {
                return Object.assign(Object.assign({}, order), { adjustedMinReturn: this.getAdjustedMinReturn(order.minReturn) });
            }
            else {
                return null;
            }
        });
    }
    getOrders(owner, includeOrdersWithNullHandler = false) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const orders = yield (0, queries_1.queryOrders)(owner, this._chainId);
            return orders
                .map((order) => (Object.assign(Object.assign({}, order), { adjustedMinReturn: this.getAdjustedMinReturn(order.minReturn) })))
                .filter((order) => {
                if (this._handler && !order.handler) {
                    return includeOrdersWithNullHandler ? true : false;
                }
                else {
                    return this._handler ? order.handler === this._handlerAddress : true;
                }
            });
        });
    }
    getOpenOrders(owner, includeOrdersWithNullHandler = false) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const orders = yield (0, queries_1.queryOpenOrders)(owner, this._chainId);
            return orders
                .map((order) => (Object.assign(Object.assign({}, order), { adjustedMinReturn: this.getAdjustedMinReturn(order.minReturn) })))
                .filter((order) => {
                if (this._handler && !order.handler) {
                    return includeOrdersWithNullHandler ? true : false;
                }
                else {
                    return this._handler ? order.handler === this._handlerAddress : true;
                }
            });
        });
    }
    getPastOrders(owner, includeOrdersWithNullHandler = false) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const orders = yield (0, queries_1.queryPastOrders)(owner, this._chainId);
            return orders
                .map((order) => (Object.assign(Object.assign({}, order), { adjustedMinReturn: this.getAdjustedMinReturn(order.minReturn) })))
                .filter((order) => {
                if (this._handler && !order.handler) {
                    return includeOrdersWithNullHandler ? true : false;
                }
                else {
                    return this._handler ? order.handler === this._handlerAddress : true;
                }
            });
        });
    }
    getExecutedOrders(owner, includeOrdersWithNullHandler = false) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const orders = yield (0, queries_1.queryExecutedOrders)(owner, this._chainId);
            return orders
                .map((order) => (Object.assign(Object.assign({}, order), { adjustedMinReturn: this.getAdjustedMinReturn(order.minReturn) })))
                .filter((order) => {
                if (this._handler && !order.handler) {
                    return includeOrdersWithNullHandler ? true : false;
                }
                else {
                    return this._handler ? order.handler === this._handlerAddress : true;
                }
            });
        });
    }
    getCancelledOrders(owner, includeOrdersWithNullHandler = false) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const orders = yield (0, queries_1.queryCancelledOrders)(owner, this._chainId);
            return orders
                .map((order) => (Object.assign(Object.assign({}, order), { adjustedMinReturn: this.getAdjustedMinReturn(order.minReturn) })))
                .filter((order) => {
                if (this._handler && !order.handler) {
                    return includeOrdersWithNullHandler ? true : false;
                }
                else {
                    return this._handler ? order.handler === this._handlerAddress : true;
                }
            });
        });
    }
    _getKey(order) {
        return ethers_1.utils.keccak256(this._abiEncoder.encode(["address", "address", "address", "address", "bytes"], [order.module, order.inputToken, order.owner, order.witness, order.data]));
    }
    _encodeSubmitData(inputToken, outputToken, owner, witness, amount, minReturn, secret, checkAllowance) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (!this._provider)
                throw new Error("No provider");
            if (inputToken.toLowerCase() === outputToken.toLowerCase())
                throw new Error("Input token and output token can not be equal");
            const encodedData = this._handlerAddress
                ? this._abiEncoder.encode(["address", "uint256", "address"], [outputToken, minReturn, this._handlerAddress])
                : this._abiEncoder.encode(["address", "uint256"], [outputToken, minReturn]);
            let data, value, to;
            if ((0, utils_1.isNetworkGasToken)(inputToken)) {
                const encodedEthOrder = yield this._gelatoLimitOrders.encodeEthOrder(this._moduleAddress, constants_1.ETH_ADDRESS, // we also use ETH_ADDRESS if it's MATIC
                owner, witness, encodedData, secret);
                data = this._gelatoLimitOrders.interface.encodeFunctionData("depositEth", [encodedEthOrder]);
                value = amount;
                to = this._gelatoLimitOrders.address;
            }
            else {
                if (checkAllowance) {
                    const allowance = yield types_1.ERC20__factory.connect(inputToken, this._provider).allowance(owner, this._erc20OrderRouter.address);
                    if (allowance.lt(amount))
                        throw new Error("Insufficient token allowance for placing order");
                }
                data = this._erc20OrderRouter.interface.encodeFunctionData("depositToken", [
                    amount,
                    this._moduleAddress,
                    inputToken,
                    owner,
                    witness,
                    encodedData,
                    secret,
                ]);
                value = ethers_1.constants.Zero;
                to = this._erc20OrderRouter.address;
            }
            return { data, value, to };
        });
    }
}
exports.GelatoLimitOrders = GelatoLimitOrders;


/***/ }),

/***/ 50105:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.GelatoBase = exports.isETHOrWETH = exports.isFlashbotsCompatibleChainId = exports.isValidChainIdAndHandler = void 0;
const tslib_1 = __webpack_require__(97582);
const ethers_1 = __webpack_require__(4730);
const abstract_provider_1 = __webpack_require__(81556);
const abstract_signer_1 = __webpack_require__(48088);
const constants_1 = __webpack_require__(89744);
const types_1 = __webpack_require__(16060);
const utils_1 = __webpack_require__(41153);
const isValidChainIdAndHandler = (chainId, handler) => {
    return constants_1.NETWORK_HANDLERS[chainId].includes(handler);
};
exports.isValidChainIdAndHandler = isValidChainIdAndHandler;
const isFlashbotsCompatibleChainId = (chainId) => {
    return chainId == constants_1.CHAIN_ID.MAINNET || chainId == constants_1.CHAIN_ID.GOERLI;
};
exports.isFlashbotsCompatibleChainId = isFlashbotsCompatibleChainId;
const isETHOrWETH = (tokenAddress, chainID) => {
    const WETH_ADDRESS = constants_1.NATIVE_WRAPPED_TOKEN_ADDRESS[chainID];
    return (tokenAddress.toLowerCase() === constants_1.ETH_ADDRESS.toLowerCase() ||
        tokenAddress.toLowerCase() === WETH_ADDRESS.toLowerCase());
};
exports.isETHOrWETH = isETHOrWETH;
class GelatoBase {
    constructor(chainId, moduleAddress, signerOrProvider, handler, handlerAddress) {
        if (handler && !(0, exports.isValidChainIdAndHandler)(chainId, handler)) {
            throw new Error("Invalid chainId and handler");
        }
        this._chainId = chainId;
        this._gelatoFeeBPS = constants_1.BPS_GELATO_FEE[chainId];
        this._slippageBPS = constants_1.STOP_LIMIT_SLIPPAGE_BPS[chainId];
        this._subgraphUrl = constants_1.SUBGRAPH_URL[chainId];
        this._signer = abstract_signer_1.Signer.isSigner(signerOrProvider)
            ? signerOrProvider
            : undefined;
        this._provider = abstract_provider_1.Provider.isProvider(signerOrProvider)
            ? signerOrProvider
            : abstract_signer_1.Signer.isSigner(signerOrProvider)
                ? signerOrProvider.provider
                : undefined;
        this._gelatoCore = this._signer
            ? types_1.GelatoLimitOrders__factory.connect(constants_1.GELATO_LIMIT_ORDERS_ADDRESS[this._chainId], this._signer)
            : this._provider
                ? types_1.GelatoLimitOrders__factory.connect(constants_1.GELATO_LIMIT_ORDERS_ADDRESS[this._chainId], this._provider)
                : new ethers_1.Contract(constants_1.GELATO_LIMIT_ORDERS_ADDRESS[this._chainId], types_1.GelatoLimitOrders__factory.createInterface());
        this._abiEncoder = new ethers_1.utils.AbiCoder();
        this._erc20OrderRouter = this._signer
            ? types_1.ERC20OrderRouter__factory.connect(constants_1.GELATO_LIMIT_ORDERS_ERC20_ORDER_ROUTER[this._chainId], this._signer)
            : this._provider
                ? types_1.ERC20OrderRouter__factory.connect(constants_1.GELATO_LIMIT_ORDERS_ERC20_ORDER_ROUTER[this._chainId], this._provider)
                : new ethers_1.Contract(constants_1.GELATO_LIMIT_ORDERS_ERC20_ORDER_ROUTER[this._chainId], types_1.ERC20OrderRouter__factory.createInterface());
        this._handler = handler;
        this._handlerAddress = handlerAddress;
        this._moduleAddress = moduleAddress;
    }
    get gelatoFeeBPS() {
        return this._gelatoFeeBPS;
    }
    get slippageBPS() {
        return this._slippageBPS;
    }
    get chainId() {
        return this._chainId;
    }
    get signer() {
        return this._signer;
    }
    get provider() {
        return this._provider;
    }
    get subgraphUrl() {
        return this._subgraphUrl;
    }
    get handler() {
        return this._handler;
    }
    get handlerAddress() {
        return this._handlerAddress;
    }
    get moduleAddress() {
        return this._moduleAddress;
    }
    get contract() {
        return this._gelatoCore;
    }
    get erc20OrderRouter() {
        return this._erc20OrderRouter;
    }
    get abiEncoder() {
        return this._abiEncoder;
    }
    encodeLimitOrderCancellation(order, checkIsActiveOrder) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (!this._gelatoCore)
                throw new Error("No gelato limit orders contract");
            if (!order.inputToken)
                throw new Error("No input token in order");
            if (!order.witness)
                throw new Error("No witness in order");
            if (!order.outputToken)
                throw new Error("No output token in order");
            if (!order.minReturn)
                throw new Error("No minReturn in order");
            if (!order.owner)
                throw new Error("No owner");
            if (checkIsActiveOrder) {
                const isActiveOrder = yield this.isActiveOrder(order);
                if (!isActiveOrder)
                    throw new Error("Order not found. Please review your order data.");
            }
            const data = this._gelatoCore.interface.encodeFunctionData("cancelOrder", [
                this._moduleAddress,
                order.inputToken,
                order.owner,
                order.witness,
                order.data,
            ]);
            return {
                data,
                to: this._gelatoCore.address,
                value: ethers_1.constants.Zero,
            };
        });
    }
    cancelStopLimitOrder(order, checkIsActiveOrder, overrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (!this._signer)
                throw new Error("No signer");
            if (!this._gelatoCore)
                throw new Error("No gelato limit orders contract");
            if (!order.inputToken)
                throw new Error("No input token in order");
            if (!order.witness)
                throw new Error("No witness in order");
            if (!order.outputToken)
                throw new Error("No output token in order");
            if (!order.minReturn)
                throw new Error("No minReturn in order");
            if (!order.data)
                throw new Error("No data in order");
            if (checkIsActiveOrder) {
                const isActiveOrder = yield this.isActiveOrder(order);
                if (!isActiveOrder)
                    throw new Error("Order not found. Please review your order data.");
            }
            const owner = yield this._signer.getAddress();
            if (owner.toLowerCase() !== order.owner.toLowerCase())
                throw new Error("Owner and signer mismatch");
            return this._gelatoCore.cancelOrder(this._moduleAddress, order.inputToken, order.owner, order.witness, order.data, overrides !== null && overrides !== void 0 ? overrides : {
                gasLimit: (0, utils_1.isEthereumChain)(this._chainId) ? 500000 : 1500000,
            });
        });
    }
    approveTokenAmount(inputToken, amount, overrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (!this._signer)
                throw new Error("No signer");
            return overrides
                ? types_1.ERC20__factory.connect(inputToken, this._signer).approve(this._erc20OrderRouter.address, amount, overrides)
                : types_1.ERC20__factory.connect(inputToken, this._signer).approve(this._erc20OrderRouter.address, amount);
        });
    }
    isActiveOrder(order) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (!this._provider)
                throw new Error("No provider");
            if (!this._gelatoCore)
                throw new Error("No gelato limit orders contract");
            if (!order.module)
                throw new Error("No module in order");
            if (!order.inputToken)
                throw new Error("No input token in order");
            if (!order.owner)
                throw new Error("No owner in order");
            if (!order.witness)
                throw new Error("No witness in order");
            if (!order.data)
                throw new Error("No data in order");
            return this._gelatoCore.existOrder(order.module, order.inputToken, order.owner, order.witness, order.data);
        });
    }
    getExchangeRate(inputValue, inputDecimals, outputValue, outputDecimals, invert = false) {
        const factor = ethers_1.BigNumber.from(10).pow(ethers_1.BigNumber.from(18));
        if (invert) {
            return ethers_1.BigNumber.from(inputValue)
                .mul(factor)
                .div(outputValue)
                .mul(ethers_1.BigNumber.from(10).pow(ethers_1.BigNumber.from(outputDecimals)))
                .div(ethers_1.BigNumber.from(10).pow(ethers_1.BigNumber.from(inputDecimals)))
                .toString();
        }
        else {
            return ethers_1.BigNumber.from(outputValue)
                .mul(factor)
                .div(inputValue)
                .mul(ethers_1.BigNumber.from(10).pow(ethers_1.BigNumber.from(inputDecimals)))
                .div(ethers_1.BigNumber.from(10).pow(ethers_1.BigNumber.from(outputDecimals)))
                .toString();
        }
    }
    getFeeAndSlippageAdjustedMinReturn(outputAmount, extraSlippageBPS) {
        if (extraSlippageBPS) {
            if (!Number.isInteger(extraSlippageBPS))
                throw new Error("Extra Slippage BPS must an unsigned integer");
        }
        const gelatoFee = ethers_1.BigNumber.from(outputAmount)
            .mul(this._gelatoFeeBPS)
            .div(10000)
            .gte(1)
            ? ethers_1.BigNumber.from(outputAmount).mul(this._gelatoFeeBPS).div(10000)
            : ethers_1.BigNumber.from(1);
        const slippageBPS = extraSlippageBPS ? extraSlippageBPS : this._slippageBPS;
        const slippage = ethers_1.BigNumber.from(outputAmount).mul(slippageBPS).div(10000);
        const minReturn = ethers_1.BigNumber.from(outputAmount).sub(gelatoFee).sub(slippage);
        return {
            minReturn: minReturn.toString(),
            slippage: slippage.toString(),
            gelatoFee: gelatoFee.toString(),
        };
    }
    getAdjustedMinReturn(minReturn, extraSlippageBPS) {
        const gelatoFee = ethers_1.BigNumber.from(this._gelatoFeeBPS);
        const slippage = extraSlippageBPS
            ? ethers_1.BigNumber.from(extraSlippageBPS)
            : ethers_1.BigNumber.from(this._slippageBPS);
        const fees = gelatoFee.add(slippage);
        const adjustedMinReturn = ethers_1.BigNumber.from(minReturn)
            .mul(10000)
            .div(ethers_1.BigNumber.from(10000).sub(fees));
        return adjustedMinReturn.toString();
    }
    getExecutionPrice(inputAmount, inputDecimals, outputAmount, outputDecimals, isInverted = false) {
        const factor = ethers_1.BigNumber.from(10).pow(ethers_1.BigNumber.from(isInverted ? outputDecimals : inputDecimals));
        if (isInverted) {
            return ethers_1.BigNumber.from(inputAmount)
                .mul(factor)
                .div(outputAmount)
                .toString();
        }
        else {
            return ethers_1.BigNumber.from(outputAmount)
                .mul(factor)
                .div(inputAmount)
                .toString();
        }
    }
    _getKey(order) {
        return ethers_1.utils.keccak256(this._abiEncoder.encode(["address", "address", "address", "address", "bytes"], [order.module, order.inputToken, order.owner, order.witness, order.data]));
    }
    _encodeSubmitData(inputToken, outputToken, owner, witness, amount, maxReturn, minReturn, secret, checkAllowance) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (!this.provider)
                throw new Error("No provider");
            if (!this.handlerAddress)
                throw new Error("No handlerAddress");
            if (inputToken.toLowerCase() === outputToken.toLowerCase())
                throw new Error("Input token and output token can not be equal");
            const encodedData = this.abiEncoder.encode(["address", "uint256", "address", "uint256"], [outputToken, minReturn, this.handlerAddress, maxReturn]);
            let data, value, to;
            if ((0, utils_1.isNetworkGasToken)(inputToken)) {
                const encodedEthOrder = yield this.contract.encodeEthOrder(this.moduleAddress, constants_1.ETH_ADDRESS, // we also use ETH_ADDRESS if it's MATIC
                owner, witness, encodedData, secret);
                data = this.contract.interface.encodeFunctionData("depositEth", [
                    encodedEthOrder,
                ]);
                value = amount;
                to = this.contract.address;
            }
            else {
                if (checkAllowance) {
                    const allowance = yield types_1.ERC20__factory.connect(inputToken, this.provider).allowance(owner, this.erc20OrderRouter.address);
                    if (allowance.lt(amount))
                        throw new Error("Insufficient token allowance for placing order");
                }
                data = this.erc20OrderRouter.interface.encodeFunctionData("depositToken", [
                    amount,
                    this.moduleAddress,
                    inputToken,
                    owner,
                    witness,
                    encodedData,
                    secret,
                ]);
                value = ethers_1.constants.Zero;
                to = this.erc20OrderRouter.address;
            }
            return { data, value, to };
        });
    }
}
exports.GelatoBase = GelatoBase;


/***/ }),

/***/ 45741:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.GelatoStopLimitOrders = void 0;
const tslib_1 = __webpack_require__(97582);
const ethers_1 = __webpack_require__(4730);
const constants_1 = __webpack_require__(89744);
const core_1 = __webpack_require__(50105);
const stoplimit_1 = __webpack_require__(73813);
class GelatoStopLimitOrders extends core_1.GelatoBase {
    constructor(chainId, signerOrProvider, handler) {
        var _a;
        if (handler && !(0, core_1.isValidChainIdAndHandler)(chainId, handler)) {
            throw new Error("Invalid chainId and handler");
        }
        const sotplossHandlers = constants_1.NETWORK_STOP_LIMIT_HANDLERS[chainId];
        if (!handler) {
            throw new Error("No Handler defined");
        }
        if (handler && !sotplossHandlers.includes(handler)) {
            throw new Error("Handler not supported");
        }
        const moduleAddress = constants_1.GELATO_STOP_LIMIT_ORDERS_MODULE_ADDRESS[chainId];
        if (!moduleAddress)
            throw new Error("Invalid chainId and handler");
        const handlerAddress = (_a = constants_1.HANDLERS_ADDRESSES[chainId][handler]) === null || _a === void 0 ? void 0 : _a.toLowerCase();
        super(chainId, moduleAddress, signerOrProvider, handler, handlerAddress);
    }
    submitStopLimitOrder(inputToken, outputToken, inputAmount, maxReturn, checkAllowance = true, overrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (!this.signer)
                throw new Error("No signer");
            if (!maxReturn)
                throw new Error("No StopLimit defined");
            const owner = yield this.signer.getAddress();
            const txData = yield this.encodeStopLimitOrderSubmission(inputToken, outputToken, inputAmount, maxReturn, owner, checkAllowance);
            return this.signer.sendTransaction(Object.assign(Object.assign({}, overrides), { to: txData.to, data: txData.data, value: ethers_1.BigNumber.from(txData.value) }));
        });
    }
    encodeStopLimitOrderSubmission(inputToken, outputToken, inputAmount, maxReturn, owner, checkAllowance = true) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { payload } = yield this.encodeStopLimitOrderSubmissionWithSecret(inputToken, outputToken, inputAmount, maxReturn, owner, checkAllowance);
            return payload;
        });
    }
    encodeStopLimitOrderSubmissionWithSecret(inputToken, outputToken, inputAmount, maxReturnToBeParsed, owner, checkAllowance = true) {
        var _a;
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (!maxReturnToBeParsed)
                throw new Error("No StopLimit defined");
            if (!this.handlerAddress)
                throw new Error("No handlerAddress");
            const randomSecret = ethers_1.utils.hexlify(ethers_1.utils.randomBytes(19)).replace("0x", "");
            // 0x67656c61746f6e6574776f726b = gelatonetwork in hex
            const fullSecret = `0x67656c61746f6e6574776f726b${randomSecret}`;
            const { privateKey: secret, address: witness } = new ethers_1.Wallet(fullSecret);
            const { minReturn } = this.getFeeAndSlippageAdjustedMinReturn(maxReturnToBeParsed);
            const payload = yield this._encodeSubmitData(inputToken, outputToken, owner, witness, inputAmount, maxReturnToBeParsed, minReturn, secret, checkAllowance);
            const encodedData = this.abiEncoder.encode(["address", "uint256", "address", "uint256"], [outputToken, minReturn, this.handlerAddress, maxReturnToBeParsed]);
            return {
                payload,
                secret,
                witness,
                order: {
                    id: this._getKey({
                        module: this.moduleAddress,
                        inputToken,
                        owner,
                        witness,
                        data: encodedData,
                    }),
                    module: this.moduleAddress.toLowerCase(),
                    data: encodedData,
                    inputToken: inputToken.toLowerCase(),
                    outputToken: outputToken.toLowerCase(),
                    owner: owner.toLowerCase(),
                    witness: witness.toLowerCase(),
                    inputAmount: inputAmount.toString(),
                    minReturn: minReturn.toString(),
                    maxReturn: maxReturnToBeParsed.toString(),
                    adjustedMinReturn: maxReturnToBeParsed.toString(),
                    inputData: payload.data.toString(),
                    secret: secret.toLowerCase(),
                    handler: (_a = this.handlerAddress) !== null && _a !== void 0 ? _a : null,
                },
            };
        });
    }
    getOpenStopLimitOrders(owner) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const orders = yield (0, stoplimit_1.queryStopLimitOrders)(owner, this.chainId);
            return orders.map((order) => (Object.assign(Object.assign({}, order), { adjustedMinReturn: this.getAdjustedMinReturn(order.minReturn) })));
        });
    }
    getStopLimitOrders(owner) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const orders = yield (0, stoplimit_1.queryStopLimitOrders)(owner, this.chainId);
            return orders.map((order) => (Object.assign(Object.assign({}, order), { adjustedMinReturn: this.getAdjustedMinReturn(order.minReturn) })));
        });
    }
    getExecutedStopLimitOrders(owner) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const orders = yield (0, stoplimit_1.queryStopLimitExecutedOrders)(owner, this.chainId);
            return orders.map((order) => (Object.assign(Object.assign({}, order), { adjustedMinReturn: this.getAdjustedMinReturn(order.minReturn) })));
        });
    }
    getCancelledStopLimitOrders(owner) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const orders = yield (0, stoplimit_1.queryStopLimitCancelledOrders)(owner, this.chainId);
            return orders.map((order) => (Object.assign(Object.assign({}, order), { adjustedMinReturn: this.getAdjustedMinReturn(order.minReturn) })));
        });
    }
    getPastStopLimitOrders(owner) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const orders = yield (0, stoplimit_1.queryPastOrders)(owner, this.chainId);
            return orders.map((order) => (Object.assign(Object.assign({}, order), { adjustedMinReturn: this.getAdjustedMinReturn(order.minReturn) })));
        });
    }
}
exports.GelatoStopLimitOrders = GelatoStopLimitOrders;


/***/ }),

/***/ 82938:
/***/ (function(__unused_webpack_module, exports) {


Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ 41153:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.isEthereumChain = exports.isTransactionCostDependentChain = exports.isNetworkGasToken = exports.queries = void 0;
const tslib_1 = __webpack_require__(97582);
const constants_1 = __webpack_require__(89744);
exports.queries = tslib_1.__importStar(__webpack_require__(39258));
const isNetworkGasToken = (token) => {
    if (token.toLowerCase() === constants_1.ETH_ADDRESS.toLowerCase()) {
        return true;
    }
    else {
        return false;
    }
};
exports.isNetworkGasToken = isNetworkGasToken;
const isTransactionCostDependentChain = (chainId) => {
    switch (chainId) {
        case 1:
            return true;
        case 3:
            return true;
        case 5:
            return true;
        case 25:
            return true;
        case 56:
            return true;
        case 250:
            return true;
        case 43114:
            return true;
        default:
            return false;
    }
};
exports.isTransactionCostDependentChain = isTransactionCostDependentChain;
const isEthereumChain = (chainId) => {
    switch (chainId) {
        case 1:
            return true;
        case 3:
            return true;
        case 5:
            return true;
        default:
            return false;
    }
};
exports.isEthereumChain = isEthereumChain;


/***/ }),

/***/ 39258:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.GET_ALL_STOP_LIMIT_ORDERS_BY_OWNER = exports.GET_ALL_CANCELLED_ORDERS_BY_OWNER = exports.GET_ALL_EXECUTED_ORDERS_BY_OWNER = exports.GET_ALL_PAST_ORDERS_BY_OWNER = exports.GET_ALL_OPEN_ORDERS_BY_OWNER = exports.GET_ALL_ORDERS_BY_OWNER = exports.GET_ORDER_BY_ID = void 0;
const graphql_request_1 = __webpack_require__(66729);
exports.GET_ORDER_BY_ID = (0, graphql_request_1.gql) `
  query getOrdersByOwner($id: String) {
    orders(where: { id: $id }) {
      id
      owner
      inputToken
      outputToken
      minReturn
      module
      witness
      secret
      inputAmount
      vault
      bought
      auxData
      status
      createdTxHash
      executedTxHash
      cancelledTxHash
      blockNumber
      createdAt
      updatedAt
      updatedAtBlock
      updatedAtBlockHash
      data
      inputData
      handler
    }
  }
`;
exports.GET_ALL_ORDERS_BY_OWNER = (0, graphql_request_1.gql) `
  query getOrdersByOwner($owner: String) {
    orders(
      first: 1000
      orderBy: updatedAtBlock
      orderDirection: desc
      where: { owner: $owner }
    ) {
      id
      owner
      inputToken
      outputToken
      minReturn
      module
      witness
      secret
      inputAmount
      vault
      bought
      auxData
      status
      createdTxHash
      executedTxHash
      cancelledTxHash
      blockNumber
      createdAt
      updatedAt
      updatedAtBlock
      updatedAtBlockHash
      data
      inputData
      handler
    }
  }
`;
exports.GET_ALL_OPEN_ORDERS_BY_OWNER = (0, graphql_request_1.gql) `
  query getOpenOrdersByOwner($owner: String) {
    orders(
      first: 1000
      orderBy: updatedAtBlock
      orderDirection: desc
      where: { owner: $owner, status: open }
    ) {
      id
      owner
      inputToken
      outputToken
      minReturn
      module
      witness
      secret
      inputAmount
      vault
      bought
      auxData
      status
      createdTxHash
      executedTxHash
      cancelledTxHash
      blockNumber
      createdAt
      updatedAt
      updatedAtBlock
      updatedAtBlockHash
      data
      inputData
      handler
    }
  }
`;
exports.GET_ALL_PAST_ORDERS_BY_OWNER = (0, graphql_request_1.gql) `
  query getPastOrdersByOwner($owner: String) {
    orders(
      first: 1000
      orderBy: updatedAtBlock
      orderDirection: desc
      where: { owner: $owner, status_not: open }
    ) {
      id
      owner
      inputToken
      outputToken
      minReturn
      module
      witness
      secret
      inputAmount
      vault
      bought
      auxData
      status
      createdTxHash
      executedTxHash
      cancelledTxHash
      blockNumber
      createdAt
      updatedAt
      updatedAtBlock
      updatedAtBlockHash
      data
      inputData
      handler
    }
  }
`;
exports.GET_ALL_EXECUTED_ORDERS_BY_OWNER = (0, graphql_request_1.gql) `
  query getExecutedOrdersByOwner($owner: String) {
    orders(
      first: 1000
      orderBy: updatedAtBlock
      orderDirection: desc
      where: { owner: $owner, status: executed }
    ) {
      id
      owner
      inputToken
      outputToken
      minReturn
      module
      witness
      secret
      inputAmount
      vault
      bought
      auxData
      status
      createdTxHash
      executedTxHash
      cancelledTxHash
      blockNumber
      createdAt
      updatedAt
      updatedAtBlock
      updatedAtBlockHash
      data
      inputData
      handler
    }
  }
`;
exports.GET_ALL_CANCELLED_ORDERS_BY_OWNER = (0, graphql_request_1.gql) `
  query getCancelledOrdersByOwner($owner: String) {
    orders(
      first: 1000
      orderBy: updatedAtBlock
      orderDirection: desc
      where: { owner: $owner, status: cancelled }
    ) {
      id
      owner
      inputToken
      outputToken
      minReturn
      module
      witness
      secret
      inputAmount
      vault
      bought
      auxData
      status
      createdTxHash
      executedTxHash
      cancelledTxHash
      blockNumber
      createdAt
      updatedAt
      updatedAtBlock
      updatedAtBlockHash
      data
      inputData
      handler
    }
  }
`;
exports.GET_ALL_STOP_LIMIT_ORDERS_BY_OWNER = (0, graphql_request_1.gql) `
  query getOrdersByOwner($owner: String, $module: String) {
    orders(
      first: 1000
      orderBy: updatedAtBlock
      orderDirection: desc
      where: { owner: $owner, module: $module }
    ) {
      id
      owner
      inputToken
      outputToken
      minReturn
      maxReturn
      module
      witness
      secret
      inputAmount
      vault
      bought
      auxData
      status
      createdTxHash
      executedTxHash
      cancelledTxHash
      blockNumber
      createdAt
      updatedAt
      updatedAtBlock
      updatedAtBlockHash
      data
      inputData
      handler
    }
  }
`;


/***/ }),

/***/ 40615:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.queryCancelledOrders = exports.queryExecutedOrders = exports.queryPastOrders = exports.queryOpenOrders = exports.queryOrders = exports.queryOrder = void 0;
const tslib_1 = __webpack_require__(97582);
const graphql_request_1 = __webpack_require__(66729);
const constants_1 = __webpack_require__(89744);
const constants_2 = __webpack_require__(39258);
const stopLimitModule = (chainId) => constants_1.GELATO_STOP_LIMIT_ORDERS_MODULE_ADDRESS[chainId].toLowerCase();
const queryOrder = (orderId, chainId) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    var _a;
    try {
        const dataFromOldSubgraph = constants_1.OLD_SUBGRAPH_URL[chainId]
            ? yield (0, graphql_request_1.request)(constants_1.OLD_SUBGRAPH_URL[chainId], constants_2.GET_ORDER_BY_ID, {
                id: orderId.toLowerCase(),
            })
            : { orders: [] };
        const dataFromNewSubgraph = constants_1.SUBGRAPH_URL[chainId]
            ? yield (0, graphql_request_1.request)(constants_1.SUBGRAPH_URL[chainId], constants_2.GET_ORDER_BY_ID, {
                id: orderId.toLowerCase(),
            })
            : { orders: [] };
        const allOrders = [
            ...dataFromOldSubgraph.orders,
            ...dataFromNewSubgraph.orders,
        ];
        return (_a = _getUniqueOrdersWithExpiry(allOrders, chainId).pop()) !== null && _a !== void 0 ? _a : null;
    }
    catch (error) {
        throw new Error("Could not query subgraph for all orders");
    }
});
exports.queryOrder = queryOrder;
const queryOrders = (owner, chainId) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    try {
        const dataFromOldSubgraph = constants_1.OLD_SUBGRAPH_URL[chainId]
            ? yield (0, graphql_request_1.request)(constants_1.OLD_SUBGRAPH_URL[chainId], constants_2.GET_ALL_ORDERS_BY_OWNER, {
                owner: owner.toLowerCase(),
            })
            : { orders: [] };
        const dataFromNewSubgraph = constants_1.SUBGRAPH_URL[chainId]
            ? yield (0, graphql_request_1.request)(constants_1.SUBGRAPH_URL[chainId], constants_2.GET_ALL_ORDERS_BY_OWNER, {
                owner: owner.toLowerCase(),
            })
            : { orders: [] };
        const allOrders = [
            ...dataFromOldSubgraph.orders,
            ...dataFromNewSubgraph.orders,
        ];
        return _getUniqueOrdersWithExpiry(allOrders, chainId);
    }
    catch (error) {
        throw new Error("Could not query subgraph for all orders");
    }
});
exports.queryOrders = queryOrders;
const queryOpenOrders = (owner, chainId) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    try {
        const dataFromOldSubgraph = constants_1.OLD_SUBGRAPH_URL[chainId]
            ? yield (0, graphql_request_1.request)(constants_1.OLD_SUBGRAPH_URL[chainId], constants_2.GET_ALL_ORDERS_BY_OWNER, {
                owner: owner.toLowerCase(),
            })
            : { orders: [] };
        const dataFromNewSubgraph = constants_1.SUBGRAPH_URL[chainId]
            ? yield (0, graphql_request_1.request)(constants_1.SUBGRAPH_URL[chainId], constants_2.GET_ALL_ORDERS_BY_OWNER, {
                owner: owner.toLowerCase(),
            })
            : { orders: [] };
        const allOrders = [
            ...dataFromOldSubgraph.orders,
            ...dataFromNewSubgraph.orders,
        ];
        return _getUniqueOrdersWithExpiry(allOrders, chainId).filter((order) => order.status === "open");
    }
    catch (error) {
        throw new Error("Could not query subgraph for open orders");
    }
});
exports.queryOpenOrders = queryOpenOrders;
const queryPastOrders = (owner, chainId) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    try {
        const dataFromOldSubgraph = constants_1.OLD_SUBGRAPH_URL[chainId]
            ? yield (0, graphql_request_1.request)(constants_1.OLD_SUBGRAPH_URL[chainId], constants_2.GET_ALL_ORDERS_BY_OWNER, {
                owner: owner.toLowerCase(),
            })
            : { orders: [] };
        const dataFromNewSubgraph = constants_1.SUBGRAPH_URL[chainId]
            ? yield (0, graphql_request_1.request)(constants_1.SUBGRAPH_URL[chainId], constants_2.GET_ALL_ORDERS_BY_OWNER, {
                owner: owner.toLowerCase(),
            })
            : { orders: [] };
        const allOrders = [
            ...dataFromOldSubgraph.orders,
            ...dataFromNewSubgraph.orders,
        ];
        return _getUniqueOrdersWithExpiry(allOrders, chainId).filter((order) => order.status !== "open");
    }
    catch (error) {
        throw new Error("Could not query subgraph for past orders");
    }
});
exports.queryPastOrders = queryPastOrders;
const queryExecutedOrders = (owner, chainId) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    try {
        const dataFromOldSubgraph = constants_1.OLD_SUBGRAPH_URL[chainId]
            ? yield (0, graphql_request_1.request)(constants_1.OLD_SUBGRAPH_URL[chainId], constants_2.GET_ALL_ORDERS_BY_OWNER, {
                owner: owner.toLowerCase(),
            })
            : { orders: [] };
        const dataFromNewSubgraph = constants_1.SUBGRAPH_URL[chainId]
            ? yield (0, graphql_request_1.request)(constants_1.SUBGRAPH_URL[chainId], constants_2.GET_ALL_ORDERS_BY_OWNER, {
                owner: owner.toLowerCase(),
            })
            : { orders: [] };
        const allOrders = [
            ...dataFromOldSubgraph.orders,
            ...dataFromNewSubgraph.orders,
        ];
        return _getUniqueOrdersWithExpiry(allOrders, chainId).filter((order) => order.status === "executed");
    }
    catch (error) {
        throw new Error("Could not query subgraph for executed orders");
    }
});
exports.queryExecutedOrders = queryExecutedOrders;
const queryCancelledOrders = (owner, chainId) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    try {
        const dataFromOldSubgraph = constants_1.OLD_SUBGRAPH_URL[chainId]
            ? yield (0, graphql_request_1.request)(constants_1.OLD_SUBGRAPH_URL[chainId], constants_2.GET_ALL_ORDERS_BY_OWNER, {
                owner: owner.toLowerCase(),
            })
            : { orders: [] };
        const dataFromNewSubgraph = constants_1.SUBGRAPH_URL[chainId]
            ? yield (0, graphql_request_1.request)(constants_1.SUBGRAPH_URL[chainId], constants_2.GET_ALL_ORDERS_BY_OWNER, {
                owner: owner.toLowerCase(),
            })
            : { orders: [] };
        const allOrders = [
            ...dataFromOldSubgraph.orders,
            ...dataFromNewSubgraph.orders,
        ];
        return _getUniqueOrdersWithExpiry(allOrders, chainId).filter((order) => order.status === "cancelled");
    }
    catch (error) {
        throw new Error("Could not query subgraph for cancelled orders");
    }
});
exports.queryCancelledOrders = queryCancelledOrders;
const _getUniqueOrdersWithExpiry = (allOrders, chainId) => 
// create Map and asign order id to order (key:value) to avoid having duplicated orders form multiple subgraphs
[...new Map(allOrders.map((order) => [order.id, order])).values()]
    // sort by `updatedAt` asc so that the most recent one will be used
    .sort((a, b) => parseFloat(a.updatedAt) - parseFloat(b.updatedAt))
    // filter out stop limit module
    .filter((order) => order.module !== stopLimitModule(chainId))
    // add expiry to order obj
    .map((order) => {
    const isExpired = Date.now() >
        (parseInt(order.createdAt) + constants_1.MAX_LIFETIME_IN_SECONDS) * 1000;
    return Object.assign(Object.assign({}, order), { isExpired });
});


/***/ }),

/***/ 73813:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports._getUniqueOrdersWithExpiry = exports.queryPastOrders = exports.queryStopLimitCancelledOrders = exports.queryStopLimitExecutedOrders = exports.queryOpenStopLimitOrders = exports.queryStopLimitOrders = void 0;
const tslib_1 = __webpack_require__(97582);
const graphql_request_1 = __webpack_require__(66729);
const constants_1 = __webpack_require__(89744);
const constants_2 = __webpack_require__(39258);
const queryStopLimitOrders = (owner, chainId) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    try {
        const dataStopLimitSubgraph = constants_1.SUBGRAPH_URL[chainId]
            ? yield (0, graphql_request_1.request)(constants_1.SUBGRAPH_URL[chainId], constants_2.GET_ALL_STOP_LIMIT_ORDERS_BY_OWNER, {
                owner: owner.toLowerCase(),
                module: constants_1.GELATO_STOP_LIMIT_ORDERS_MODULE_ADDRESS[chainId].toLowerCase(),
            })
            : { orders: [] };
        const orders = dataStopLimitSubgraph.orders;
        return (0, exports._getUniqueOrdersWithExpiry)(orders);
    }
    catch (error) {
        console.error(error);
        throw new Error("Could not query subgraph for all orders");
    }
});
exports.queryStopLimitOrders = queryStopLimitOrders;
const queryOpenStopLimitOrders = (owner, chainId) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    try {
        const dataStopLimitSubgraph = constants_1.SUBGRAPH_URL[chainId]
            ? yield (0, graphql_request_1.request)(constants_1.SUBGRAPH_URL[chainId], constants_2.GET_ALL_STOP_LIMIT_ORDERS_BY_OWNER, {
                owner: owner.toLowerCase(),
                module: constants_1.GELATO_STOP_LIMIT_ORDERS_MODULE_ADDRESS[chainId].toLowerCase(),
            })
            : { orders: [] };
        const orders = dataStopLimitSubgraph.orders;
        return (0, exports._getUniqueOrdersWithExpiry)(orders).filter((order) => order.status === "open");
    }
    catch (error) {
        throw new Error("Could not query subgraph for open orders");
    }
});
exports.queryOpenStopLimitOrders = queryOpenStopLimitOrders;
const queryStopLimitExecutedOrders = (owner, chainId) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    try {
        const dataStopLimitSubgraph = constants_1.SUBGRAPH_URL[chainId]
            ? yield (0, graphql_request_1.request)(constants_1.SUBGRAPH_URL[chainId], constants_2.GET_ALL_STOP_LIMIT_ORDERS_BY_OWNER, {
                owner: owner.toLowerCase(),
                module: constants_1.GELATO_STOP_LIMIT_ORDERS_MODULE_ADDRESS[chainId].toLowerCase(),
            })
            : { orders: [] };
        const orders = dataStopLimitSubgraph.orders;
        return (0, exports._getUniqueOrdersWithExpiry)(orders).filter((order) => order.status === "executed");
    }
    catch (error) {
        throw new Error("Could not query subgraph for executed orders");
    }
});
exports.queryStopLimitExecutedOrders = queryStopLimitExecutedOrders;
const queryStopLimitCancelledOrders = (owner, chainId) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    try {
        const dataStopLimitSubgraph = constants_1.SUBGRAPH_URL[chainId]
            ? yield (0, graphql_request_1.request)(constants_1.SUBGRAPH_URL[chainId], constants_2.GET_ALL_STOP_LIMIT_ORDERS_BY_OWNER, {
                owner: owner.toLowerCase(),
                module: constants_1.GELATO_STOP_LIMIT_ORDERS_MODULE_ADDRESS[chainId].toLowerCase(),
            })
            : { orders: [] };
        const orders = dataStopLimitSubgraph.orders;
        return (0, exports._getUniqueOrdersWithExpiry)(orders).filter((order) => order.status === "cancelled");
    }
    catch (error) {
        throw new Error("Could not query subgraph for cancelled orders");
    }
});
exports.queryStopLimitCancelledOrders = queryStopLimitCancelledOrders;
const queryPastOrders = (owner, chainId) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    try {
        const dataStopLimitSubgraph = constants_1.SUBGRAPH_URL[chainId]
            ? yield (0, graphql_request_1.request)(constants_1.SUBGRAPH_URL[chainId], constants_2.GET_ALL_STOP_LIMIT_ORDERS_BY_OWNER, {
                owner: owner.toLowerCase(),
                module: constants_1.GELATO_STOP_LIMIT_ORDERS_MODULE_ADDRESS[chainId].toLowerCase(),
            })
            : { orders: [] };
        const orders = dataStopLimitSubgraph.orders;
        return (0, exports._getUniqueOrdersWithExpiry)(orders).filter((order) => order.status !== "open");
    }
    catch (error) {
        throw new Error("Could not query subgraph for past orders");
    }
});
exports.queryPastOrders = queryPastOrders;
const _getUniqueOrdersWithExpiry = (allOrders) => [...new Map(allOrders.map((order) => [order.id, order])).values()]
    // sort by `updatedAt` asc so that the most recent one will be used
    .sort((a, b) => parseFloat(a.updatedAt) - parseFloat(b.updatedAt))
    // add expiry to order obj
    .map((order) => {
    const isExpired = Date.now() >
        (parseInt(order.createdAt) + constants_1.MAX_LIFETIME_IN_SECONDS) * 1000;
    return Object.assign(Object.assign({}, order), { isExpired });
});
exports._getUniqueOrdersWithExpiry = _getUniqueOrdersWithExpiry;


/***/ }),

/***/ 29152:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var extract_files_1 = __webpack_require__(34823);
var form_data_1 = __importDefault(__webpack_require__(6230));
/**
 * Duck type if NodeJS stream
 * https://github.com/sindresorhus/is-stream/blob/3750505b0727f6df54324784fe369365ef78841e/index.js#L3
 */
var isExtractableFileEnhanced = function (value) {
    return extract_files_1.isExtractableFile(value) ||
        (value !== null && typeof value === 'object' && typeof value.pipe === 'function');
};
/**
 * Returns Multipart Form if body contains files
 * (https://github.com/jaydenseric/graphql-multipart-request-spec)
 * Otherwise returns JSON
 */
function createRequestBody(query, variables, operationName) {
    var _a = extract_files_1.extractFiles({ query: query, variables: variables, operationName: operationName }, '', isExtractableFileEnhanced), clone = _a.clone, files = _a.files;
    if (files.size === 0) {
        if (!Array.isArray(query)) {
            return JSON.stringify(clone);
        }
        if (typeof variables !== 'undefined' && !Array.isArray(variables)) {
            throw new Error('Cannot create request body with given variable type, array expected');
        }
        // Batch support
        var payload = query.reduce(function (accu, currentQuery, index) {
            accu.push({ query: currentQuery, variables: variables ? variables[index] : undefined });
            return accu;
        }, []);
        return JSON.stringify(payload);
    }
    var Form = typeof FormData === 'undefined' ? form_data_1.default : FormData;
    var form = new Form();
    form.append('operations', JSON.stringify(clone));
    var map = {};
    var i = 0;
    files.forEach(function (paths) {
        map[++i] = paths;
    });
    form.append('map', JSON.stringify(map));
    i = 0;
    files.forEach(function (paths, file) {
        form.append("" + ++i, file);
    });
    return form;
}
exports["default"] = createRequestBody;
//# sourceMappingURL=createRequestBody.js.map

/***/ }),

/***/ 66729:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.gql = exports.batchRequests = exports.request = exports.rawRequest = exports.GraphQLClient = exports.ClientError = void 0;
var cross_fetch_1 = __importStar(__webpack_require__(54098)), CrossFetch = cross_fetch_1;
var printer_1 = __webpack_require__(91625);
var createRequestBody_1 = __importDefault(__webpack_require__(29152));
var types_1 = __webpack_require__(66321);
Object.defineProperty(exports, "ClientError", ({ enumerable: true, get: function () { return types_1.ClientError; } }));
/**
 * Convert the given headers configuration into a plain object.
 */
var resolveHeaders = function (headers) {
    var oHeaders = {};
    if (headers) {
        if ((typeof Headers !== 'undefined' && headers instanceof Headers) ||
            headers instanceof CrossFetch.Headers) {
            oHeaders = HeadersInstanceToPlainObject(headers);
        }
        else if (Array.isArray(headers)) {
            headers.forEach(function (_a) {
                var name = _a[0], value = _a[1];
                oHeaders[name] = value;
            });
        }
        else {
            oHeaders = headers;
        }
    }
    return oHeaders;
};
/**
 * Clean a GraphQL document to send it via a GET query
 *
 * @param {string} str GraphQL query
 * @returns {string} Cleaned query
 */
var queryCleanner = function (str) { return str.replace(/([\s,]|#[^\n\r]+)+/g, ' ').trim(); };
/**
 * Create query string for GraphQL request
 *
 * @param {object} param0 -
 *
 * @param {string|string[]} param0.query the GraphQL document or array of document if it's a batch request
 * @param {string|undefined} param0.operationName the GraphQL operation name
 * @param {any|any[]} param0.variables the GraphQL variables to use
 */
var buildGetQueryParams = function (_a) {
    var query = _a.query, variables = _a.variables, operationName = _a.operationName;
    if (!Array.isArray(query)) {
        var search = ["query=" + encodeURIComponent(queryCleanner(query))];
        if (variables) {
            search.push("variables=" + encodeURIComponent(JSON.stringify(variables)));
        }
        if (operationName) {
            search.push("operationName=" + encodeURIComponent(operationName));
        }
        return search.join('&');
    }
    if (typeof variables !== 'undefined' && !Array.isArray(variables)) {
        throw new Error('Cannot create query with given variable type, array expected');
    }
    // Batch support
    var payload = query.reduce(function (accu, currentQuery, index) {
        accu.push({
            query: queryCleanner(currentQuery),
            variables: variables ? JSON.stringify(variables[index]) : undefined,
        });
        return accu;
    }, []);
    return "query=" + encodeURIComponent(JSON.stringify(payload));
};
/**
 * Fetch data using POST method
 */
var post = function (_a) {
    var url = _a.url, query = _a.query, variables = _a.variables, operationName = _a.operationName, headers = _a.headers, fetch = _a.fetch, fetchOptions = _a.fetchOptions;
    return __awaiter(void 0, void 0, void 0, function () {
        var body;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    body = createRequestBody_1.default(query, variables, operationName);
                    return [4 /*yield*/, fetch(url, __assign({ method: 'POST', headers: __assign(__assign({}, (typeof body === 'string' ? { 'Content-Type': 'application/json' } : {})), headers), body: body }, fetchOptions))];
                case 1: return [2 /*return*/, _b.sent()];
            }
        });
    });
};
/**
 * Fetch data using GET method
 */
var get = function (_a) {
    var url = _a.url, query = _a.query, variables = _a.variables, operationName = _a.operationName, headers = _a.headers, fetch = _a.fetch, fetchOptions = _a.fetchOptions;
    return __awaiter(void 0, void 0, void 0, function () {
        var queryParams;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    queryParams = buildGetQueryParams({
                        query: query,
                        variables: variables,
                        operationName: operationName,
                    });
                    return [4 /*yield*/, fetch(url + "?" + queryParams, __assign({ method: 'GET', headers: headers }, fetchOptions))];
                case 1: return [2 /*return*/, _b.sent()];
            }
        });
    });
};
/**
 * todo
 */
var GraphQLClient = /** @class */ (function () {
    function GraphQLClient(url, options) {
        this.url = url;
        this.options = options || {};
    }
    GraphQLClient.prototype.rawRequest = function (query, variables, requestHeaders) {
        var _a = this.options, headers = _a.headers, _b = _a.fetch, fetch = _b === void 0 ? cross_fetch_1.default : _b, _c = _a.method, method = _c === void 0 ? 'POST' : _c, fetchOptions = __rest(_a, ["headers", "fetch", "method"]);
        var url = this.url;
        return makeRequest({
            url: url,
            query: query,
            variables: variables,
            headers: __assign(__assign({}, resolveHeaders(headers)), resolveHeaders(requestHeaders)),
            operationName: undefined,
            fetch: fetch,
            method: method,
            fetchOptions: fetchOptions,
        });
    };
    /**
     * Send a GraphQL document to the server.
     */
    GraphQLClient.prototype.request = function (document, variables, requestHeaders) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, headers, _b, fetch, _c, method, fetchOptions, url, _d, query, operationName, data;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        _a = this.options, headers = _a.headers, _b = _a.fetch, fetch = _b === void 0 ? cross_fetch_1.default : _b, _c = _a.method, method = _c === void 0 ? 'POST' : _c, fetchOptions = __rest(_a, ["headers", "fetch", "method"]);
                        url = this.url;
                        _d = resolveRequestDocument(document), query = _d.query, operationName = _d.operationName;
                        return [4 /*yield*/, makeRequest({
                                url: url,
                                query: query,
                                variables: variables,
                                headers: __assign(__assign({}, resolveHeaders(headers)), resolveHeaders(requestHeaders)),
                                operationName: operationName,
                                fetch: fetch,
                                method: method,
                                fetchOptions: fetchOptions,
                            })];
                    case 1:
                        data = (_e.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        });
    };
    /**
     * Send a GraphQL document to the server.
     */
    GraphQLClient.prototype.batchRequests = function (documents, requestHeaders) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, headers, _b, fetch, _c, method, fetchOptions, url, queries, variables, data;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _a = this.options, headers = _a.headers, _b = _a.fetch, fetch = _b === void 0 ? cross_fetch_1.default : _b, _c = _a.method, method = _c === void 0 ? 'POST' : _c, fetchOptions = __rest(_a, ["headers", "fetch", "method"]);
                        url = this.url;
                        queries = documents.map(function (_a) {
                            var document = _a.document;
                            return resolveRequestDocument(document).query;
                        });
                        variables = documents.map(function (_a) {
                            var variables = _a.variables;
                            return variables;
                        });
                        return [4 /*yield*/, makeRequest({
                                url: url,
                                query: queries,
                                variables: variables,
                                headers: __assign(__assign({}, resolveHeaders(headers)), resolveHeaders(requestHeaders)),
                                operationName: undefined,
                                fetch: fetch,
                                method: method,
                                fetchOptions: fetchOptions,
                            })];
                    case 1:
                        data = (_d.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        });
    };
    GraphQLClient.prototype.setHeaders = function (headers) {
        this.options.headers = headers;
        return this;
    };
    /**
     * Attach a header to the client. All subsequent requests will have this header.
     */
    GraphQLClient.prototype.setHeader = function (key, value) {
        var _a;
        var headers = this.options.headers;
        if (headers) {
            // todo what if headers is in nested array form... ?
            //@ts-ignore
            headers[key] = value;
        }
        else {
            this.options.headers = (_a = {}, _a[key] = value, _a);
        }
        return this;
    };
    /**
     * Change the client endpoint. All subsequent requests will send to this endpoint.
     */
    GraphQLClient.prototype.setEndpoint = function (value) {
        this.url = value;
        return this;
    };
    return GraphQLClient;
}());
exports.GraphQLClient = GraphQLClient;
function makeRequest(_a) {
    var url = _a.url, query = _a.query, variables = _a.variables, headers = _a.headers, operationName = _a.operationName, fetch = _a.fetch, _b = _a.method, method = _b === void 0 ? 'POST' : _b, fetchOptions = _a.fetchOptions;
    return __awaiter(this, void 0, void 0, function () {
        var fetcher, isBathchingQuery, response, result, successfullyReceivedData, headers_1, status_1, errorResult;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    fetcher = method.toUpperCase() === 'POST' ? post : get;
                    isBathchingQuery = Array.isArray(query);
                    return [4 /*yield*/, fetcher({
                            url: url,
                            query: query,
                            variables: variables,
                            operationName: operationName,
                            headers: headers,
                            fetch: fetch,
                            fetchOptions: fetchOptions,
                        })];
                case 1:
                    response = _c.sent();
                    return [4 /*yield*/, getResult(response)];
                case 2:
                    result = _c.sent();
                    successfullyReceivedData = isBathchingQuery && Array.isArray(result) ? !result.some(function (_a) {
                        var data = _a.data;
                        return !data;
                    }) : !!result.data;
                    if (response.ok && !result.errors && successfullyReceivedData) {
                        headers_1 = response.headers, status_1 = response.status;
                        return [2 /*return*/, __assign(__assign({}, (isBathchingQuery ? { data: result } : result)), { headers: headers_1, status: status_1 })];
                    }
                    else {
                        errorResult = typeof result === 'string' ? { error: result } : result;
                        throw new types_1.ClientError(__assign(__assign({}, errorResult), { status: response.status, headers: response.headers }), { query: query, variables: variables });
                    }
                    return [2 /*return*/];
            }
        });
    });
}
/**
 * todo
 */
function rawRequest(url, query, variables, requestHeaders) {
    return __awaiter(this, void 0, void 0, function () {
        var client;
        return __generator(this, function (_a) {
            client = new GraphQLClient(url);
            return [2 /*return*/, client.rawRequest(query, variables, requestHeaders)];
        });
    });
}
exports.rawRequest = rawRequest;
/**
 * Send a GraphQL Document to the GraphQL server for exectuion.
 *
 * @example
 *
 * ```ts
 * // You can pass a raw string
 *
 * await request('https://foo.bar/graphql', `
 *   {
 *     query {
 *       users
 *     }
 *   }
 * `)
 *
 * // You can also pass a GraphQL DocumentNode. Convenient if you
 * // are using graphql-tag package.
 *
 * import gql from 'graphql-tag'
 *
 * await request('https://foo.bar/graphql', gql`...`)
 *
 * // If you don't actually care about using DocumentNode but just
 * // want the tooling support for gql template tag like IDE syntax
 * // coloring and prettier autoformat then note you can use the
 * // passthrough gql tag shipped with graphql-request to save a bit
 * // of performance and not have to install another dep into your project.
 *
 * import { gql } from 'graphql-request'
 *
 * await request('https://foo.bar/graphql', gql`...`)
 * ```
 */
function request(url, document, variables, requestHeaders) {
    return __awaiter(this, void 0, void 0, function () {
        var client;
        return __generator(this, function (_a) {
            client = new GraphQLClient(url);
            return [2 /*return*/, client.request(document, variables, requestHeaders)];
        });
    });
}
exports.request = request;
/**
 * Send a batch of GraphQL Document to the GraphQL server for exectuion.
 *
 * @example
 *
 * ```ts
 * // You can pass a raw string
 *
 * await batchRequests('https://foo.bar/graphql', [
 * {
 *  query: `
 *   {
 *     query {
 *       users
 *     }
 *   }`
 * },
 * {
 *   query: `
 *   {
 *     query {
 *       users
 *     }
 *   }`
 * }])
 *
 * // You can also pass a GraphQL DocumentNode as query. Convenient if you
 * // are using graphql-tag package.
 *
 * import gql from 'graphql-tag'
 *
 * await batchRequests('https://foo.bar/graphql', [{ query: gql`...` }])
 * ```
 */
function batchRequests(url, documents, requestHeaders) {
    return __awaiter(this, void 0, void 0, function () {
        var client;
        return __generator(this, function (_a) {
            client = new GraphQLClient(url);
            return [2 /*return*/, client.batchRequests(documents, requestHeaders)];
        });
    });
}
exports.batchRequests = batchRequests;
exports["default"] = request;
/**
 * todo
 */
function getResult(response) {
    var contentType = response.headers.get('Content-Type');
    if (contentType && contentType.startsWith('application/json')) {
        return response.json();
    }
    else {
        return response.text();
    }
}
/**
 * helpers
 */
function resolveRequestDocument(document) {
    var _a;
    if (typeof document === 'string')
        return { query: document };
    var operationName = undefined;
    var operationDefinitions = document.definitions.filter(function (definition) { return definition.kind === 'OperationDefinition'; });
    if (operationDefinitions.length === 1) {
        operationName = (_a = operationDefinitions[0].name) === null || _a === void 0 ? void 0 : _a.value;
    }
    return { query: printer_1.print(document), operationName: operationName };
}
/**
 * Convenience passthrough template tag to get the benefits of tooling for the gql template tag. This does not actually parse the input into a GraphQL DocumentNode like graphql-tag package does. It just returns the string with any variables given interpolated. Can save you a bit of performance and having to install another package.
 *
 * @example
 *
 * import { gql } from 'graphql-request'
 *
 * await request('https://foo.bar/graphql', gql`...`)
 *
 * @remarks
 *
 * Several tools in the Node GraphQL ecosystem are hardcoded to specially treat any template tag named "gql". For example see this prettier issue: https://github.com/prettier/prettier/issues/4360. Using this template tag has no runtime effect beyond variable interpolation.
 */
function gql(chunks) {
    var variables = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        variables[_i - 1] = arguments[_i];
    }
    return chunks.reduce(function (accumulator, chunk, index) { return "" + accumulator + chunk + (index in variables ? variables[index] : ''); }, '');
}
exports.gql = gql;
/**
 * Convert Headers instance into regular object
 */
function HeadersInstanceToPlainObject(headers) {
    var o = {};
    headers.forEach(function (v, k) {
        o[k] = v;
    });
    return o;
}
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 66321:
/***/ (function(__unused_webpack_module, exports) {


var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ClientError = void 0;
var ClientError = /** @class */ (function (_super) {
    __extends(ClientError, _super);
    function ClientError(response, request) {
        var _this = this;
        var message = ClientError.extractMessage(response) + ": " + JSON.stringify({
            response: response,
            request: request,
        });
        _this = _super.call(this, message) || this;
        Object.setPrototypeOf(_this, ClientError.prototype);
        _this.response = response;
        _this.request = request;
        // this is needed as Safari doesn't support .captureStackTrace
        if (typeof Error.captureStackTrace === 'function') {
            Error.captureStackTrace(_this, ClientError);
        }
        return _this;
    }
    ClientError.extractMessage = function (response) {
        try {
            return response.errors[0].message;
        }
        catch (e) {
            return "GraphQL Error (Code: " + response.status + ")";
        }
    };
    return ClientError;
}(Error));
exports.ClientError = ClientError;
//# sourceMappingURL=types.js.map

/***/ }),

/***/ 4730:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "BaseContract": function() { return /* reexport */ lib_esm/* BaseContract */.VZ; },
  "BigNumber": function() { return /* reexport */ bignumber/* BigNumber */.O$; },
  "Contract": function() { return /* reexport */ lib_esm/* Contract */.CH; },
  "ContractFactory": function() { return /* reexport */ lib_esm/* ContractFactory */.lV; },
  "FixedNumber": function() { return /* reexport */ fixednumber/* FixedNumber */.xs; },
  "Signer": function() { return /* reexport */ abstract_signer_lib_esm.Signer; },
  "VoidSigner": function() { return /* reexport */ abstract_signer_lib_esm.VoidSigner; },
  "Wallet": function() { return /* reexport */ wallet_lib_esm.Wallet; },
  "Wordlist": function() { return /* reexport */ wordlist/* Wordlist */.D; },
  "constants": function() { return /* reexport */ constants_lib_esm; },
  "errors": function() { return /* reexport */ logger_lib_esm.ErrorCode; },
  "ethers": function() { return /* reexport */ ethers_namespaceObject; },
  "getDefaultProvider": function() { return /* reexport */ providers_lib_esm.getDefaultProvider; },
  "logger": function() { return /* reexport */ logger; },
  "providers": function() { return /* reexport */ providers_lib_esm; },
  "utils": function() { return /* reexport */ utils; },
  "version": function() { return /* reexport */ version; },
  "wordlists": function() { return /* reexport */ wordlists/* wordlists */.E; }
});

// NAMESPACE OBJECT: ./node_modules/ethers/lib.esm/ethers.js
var ethers_namespaceObject = {};
__webpack_require__.r(ethers_namespaceObject);
__webpack_require__.d(ethers_namespaceObject, {
  "BaseContract": function() { return lib_esm/* BaseContract */.VZ; },
  "BigNumber": function() { return bignumber/* BigNumber */.O$; },
  "Contract": function() { return lib_esm/* Contract */.CH; },
  "ContractFactory": function() { return lib_esm/* ContractFactory */.lV; },
  "FixedNumber": function() { return fixednumber/* FixedNumber */.xs; },
  "Signer": function() { return abstract_signer_lib_esm.Signer; },
  "VoidSigner": function() { return abstract_signer_lib_esm.VoidSigner; },
  "Wallet": function() { return wallet_lib_esm.Wallet; },
  "Wordlist": function() { return wordlist/* Wordlist */.D; },
  "constants": function() { return constants_lib_esm; },
  "errors": function() { return logger_lib_esm.ErrorCode; },
  "getDefaultProvider": function() { return providers_lib_esm.getDefaultProvider; },
  "logger": function() { return logger; },
  "providers": function() { return providers_lib_esm; },
  "utils": function() { return utils; },
  "version": function() { return version; },
  "wordlists": function() { return wordlists/* wordlists */.E; }
});

// EXTERNAL MODULE: ./node_modules/@ethersproject/contracts/lib.esm/index.js + 1 modules
var lib_esm = __webpack_require__(64146);
// EXTERNAL MODULE: ./node_modules/@ethersproject/bignumber/lib.esm/bignumber.js
var bignumber = __webpack_require__(2593);
// EXTERNAL MODULE: ./node_modules/@ethersproject/bignumber/lib.esm/fixednumber.js
var fixednumber = __webpack_require__(20335);
// EXTERNAL MODULE: ./node_modules/@ethersproject/abstract-signer/lib.esm/index.js + 1 modules
var abstract_signer_lib_esm = __webpack_require__(48088);
// EXTERNAL MODULE: ./node_modules/@ethersproject/wallet/lib.esm/index.js + 1 modules
var wallet_lib_esm = __webpack_require__(79911);
// EXTERNAL MODULE: ./node_modules/@ethersproject/constants/lib.esm/index.js + 1 modules
var constants_lib_esm = __webpack_require__(21815);
// EXTERNAL MODULE: ./node_modules/@ethersproject/providers/lib.esm/index.js + 9 modules
var providers_lib_esm = __webpack_require__(88901);
// EXTERNAL MODULE: ./node_modules/@ethersproject/wordlists/lib.esm/wordlists.js + 1 modules
var wordlists = __webpack_require__(10234);
// EXTERNAL MODULE: ./node_modules/@ethersproject/wordlists/lib.esm/wordlist.js + 1 modules
var wordlist = __webpack_require__(48812);
// EXTERNAL MODULE: ./node_modules/ethers/lib.esm/utils.js
var utils = __webpack_require__(86494);
// EXTERNAL MODULE: ./node_modules/@ethersproject/logger/lib.esm/index.js + 1 modules
var logger_lib_esm = __webpack_require__(1581);
;// CONCATENATED MODULE: ./node_modules/ethers/lib.esm/_version.js
const version = "ethers/5.7.2";
//# sourceMappingURL=_version.js.map
;// CONCATENATED MODULE: ./node_modules/ethers/lib.esm/ethers.js











////////////////////////
// Compile-Time Constants
// This is generated by "npm run dist"

const logger = new logger_lib_esm.Logger(version);
////////////////////////
// Exports

//# sourceMappingURL=ethers.js.map
;// CONCATENATED MODULE: ./node_modules/ethers/lib.esm/index.js

// To modify this file, you must update ./misc/admin/lib/cmds/update-exports.js

try {
    const anyGlobal = window;
    if (anyGlobal._ethers == null) {
        anyGlobal._ethers = ethers_namespaceObject;
    }
}
catch (error) { }


//# sourceMappingURL=index.js.map

/***/ }),

/***/ 34823:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



exports.ReactNativeFile = __webpack_require__(72445);
exports.extractFiles = __webpack_require__(40804);
exports.isExtractableFile = __webpack_require__(51268);


/***/ }),

/***/ 91625:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "print": function() { return /* binding */ print; }
});

;// CONCATENATED MODULE: ./node_modules/@gelatonetwork/limit-orders-lib/node_modules/graphql/jsutils/nodejsCustomInspectSymbol.mjs
// istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var nodejsCustomInspectSymbol = typeof Symbol === 'function' && typeof Symbol.for === 'function' ? Symbol.for('nodejs.util.inspect.custom') : undefined;
/* harmony default export */ var jsutils_nodejsCustomInspectSymbol = (nodejsCustomInspectSymbol);

;// CONCATENATED MODULE: ./node_modules/@gelatonetwork/limit-orders-lib/node_modules/graphql/jsutils/inspect.mjs
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/* eslint-disable flowtype/no-weak-types */

var MAX_ARRAY_LENGTH = 10;
var MAX_RECURSIVE_DEPTH = 2;
/**
 * Used to print values in error messages.
 */

function inspect(value) {
  return formatValue(value, []);
}

function formatValue(value, seenValues) {
  switch (_typeof(value)) {
    case 'string':
      return JSON.stringify(value);

    case 'function':
      return value.name ? "[function ".concat(value.name, "]") : '[function]';

    case 'object':
      if (value === null) {
        return 'null';
      }

      return formatObjectValue(value, seenValues);

    default:
      return String(value);
  }
}

function formatObjectValue(value, previouslySeenValues) {
  if (previouslySeenValues.indexOf(value) !== -1) {
    return '[Circular]';
  }

  var seenValues = [].concat(previouslySeenValues, [value]);
  var customInspectFn = getCustomFn(value);

  if (customInspectFn !== undefined) {
    var customValue = customInspectFn.call(value); // check for infinite recursion

    if (customValue !== value) {
      return typeof customValue === 'string' ? customValue : formatValue(customValue, seenValues);
    }
  } else if (Array.isArray(value)) {
    return formatArray(value, seenValues);
  }

  return formatObject(value, seenValues);
}

function formatObject(object, seenValues) {
  var keys = Object.keys(object);

  if (keys.length === 0) {
    return '{}';
  }

  if (seenValues.length > MAX_RECURSIVE_DEPTH) {
    return '[' + getObjectTag(object) + ']';
  }

  var properties = keys.map(function (key) {
    var value = formatValue(object[key], seenValues);
    return key + ': ' + value;
  });
  return '{ ' + properties.join(', ') + ' }';
}

function formatArray(array, seenValues) {
  if (array.length === 0) {
    return '[]';
  }

  if (seenValues.length > MAX_RECURSIVE_DEPTH) {
    return '[Array]';
  }

  var len = Math.min(MAX_ARRAY_LENGTH, array.length);
  var remaining = array.length - len;
  var items = [];

  for (var i = 0; i < len; ++i) {
    items.push(formatValue(array[i], seenValues));
  }

  if (remaining === 1) {
    items.push('... 1 more item');
  } else if (remaining > 1) {
    items.push("... ".concat(remaining, " more items"));
  }

  return '[' + items.join(', ') + ']';
}

function getCustomFn(object) {
  var customInspectFn = object[String(jsutils_nodejsCustomInspectSymbol)];

  if (typeof customInspectFn === 'function') {
    return customInspectFn;
  }

  if (typeof object.inspect === 'function') {
    return object.inspect;
  }
}

function getObjectTag(object) {
  var tag = Object.prototype.toString.call(object).replace(/^\[object /, '').replace(/]$/, '');

  if (tag === 'Object' && typeof object.constructor === 'function') {
    var name = object.constructor.name;

    if (typeof name === 'string' && name !== '') {
      return name;
    }
  }

  return tag;
}

;// CONCATENATED MODULE: ./node_modules/@gelatonetwork/limit-orders-lib/node_modules/graphql/jsutils/invariant.mjs
function invariant(condition, message) {
  var booleanCondition = Boolean(condition); // istanbul ignore else (See transformation done in './resources/inlineInvariant.js')

  if (!booleanCondition) {
    throw new Error(message != null ? message : 'Unexpected invariant triggered.');
  }
}

;// CONCATENATED MODULE: ./node_modules/@gelatonetwork/limit-orders-lib/node_modules/graphql/jsutils/defineInspect.mjs


/**
 * The `defineInspect()` function defines `inspect()` prototype method as alias of `toJSON`
 */

function defineInspect(classObject) {
  var fn = classObject.prototype.toJSON;
  typeof fn === 'function' || invariant(0);
  classObject.prototype.inspect = fn; // istanbul ignore else (See: 'https://github.com/graphql/graphql-js/issues/2317')

  if (jsutils_nodejsCustomInspectSymbol) {
    classObject.prototype[jsutils_nodejsCustomInspectSymbol] = fn;
  }
}

;// CONCATENATED MODULE: ./node_modules/@gelatonetwork/limit-orders-lib/node_modules/graphql/language/ast.mjs


/**
 * Contains a range of UTF-8 character offsets and token references that
 * identify the region of the source from which the AST derived.
 */
var Location = /*#__PURE__*/function () {
  /**
   * The character offset at which this Node begins.
   */

  /**
   * The character offset at which this Node ends.
   */

  /**
   * The Token at which this Node begins.
   */

  /**
   * The Token at which this Node ends.
   */

  /**
   * The Source document the AST represents.
   */
  function Location(startToken, endToken, source) {
    this.start = startToken.start;
    this.end = endToken.end;
    this.startToken = startToken;
    this.endToken = endToken;
    this.source = source;
  }

  var _proto = Location.prototype;

  _proto.toJSON = function toJSON() {
    return {
      start: this.start,
      end: this.end
    };
  };

  return Location;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.

defineInspect(Location);
/**
 * Represents a range of characters represented by a lexical token
 * within a Source.
 */

var Token = /*#__PURE__*/function () {
  /**
   * The kind of Token.
   */

  /**
   * The character offset at which this Node begins.
   */

  /**
   * The character offset at which this Node ends.
   */

  /**
   * The 1-indexed line number on which this Token appears.
   */

  /**
   * The 1-indexed column number at which this Token begins.
   */

  /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   */

  /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */
  function Token(kind, start, end, line, column, prev, value) {
    this.kind = kind;
    this.start = start;
    this.end = end;
    this.line = line;
    this.column = column;
    this.value = value;
    this.prev = prev;
    this.next = null;
  }

  var _proto2 = Token.prototype;

  _proto2.toJSON = function toJSON() {
    return {
      kind: this.kind,
      value: this.value,
      line: this.line,
      column: this.column
    };
  };

  return Token;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.

defineInspect(Token);
/**
 * @internal
 */

function isNode(maybeNode) {
  return maybeNode != null && typeof maybeNode.kind === 'string';
}
/**
 * The list of all possible AST node types.
 */

;// CONCATENATED MODULE: ./node_modules/@gelatonetwork/limit-orders-lib/node_modules/graphql/language/visitor.mjs


/**
 * A visitor is provided to visit, it contains the collection of
 * relevant functions to be called during the visitor's traversal.
 */

var QueryDocumentKeys = {
  Name: [],
  Document: ['definitions'],
  OperationDefinition: ['name', 'variableDefinitions', 'directives', 'selectionSet'],
  VariableDefinition: ['variable', 'type', 'defaultValue', 'directives'],
  Variable: ['name'],
  SelectionSet: ['selections'],
  Field: ['alias', 'name', 'arguments', 'directives', 'selectionSet'],
  Argument: ['name', 'value'],
  FragmentSpread: ['name', 'directives'],
  InlineFragment: ['typeCondition', 'directives', 'selectionSet'],
  FragmentDefinition: ['name', // Note: fragment variable definitions are experimental and may be changed
  // or removed in the future.
  'variableDefinitions', 'typeCondition', 'directives', 'selectionSet'],
  IntValue: [],
  FloatValue: [],
  StringValue: [],
  BooleanValue: [],
  NullValue: [],
  EnumValue: [],
  ListValue: ['values'],
  ObjectValue: ['fields'],
  ObjectField: ['name', 'value'],
  Directive: ['name', 'arguments'],
  NamedType: ['name'],
  ListType: ['type'],
  NonNullType: ['type'],
  SchemaDefinition: ['description', 'directives', 'operationTypes'],
  OperationTypeDefinition: ['type'],
  ScalarTypeDefinition: ['description', 'name', 'directives'],
  ObjectTypeDefinition: ['description', 'name', 'interfaces', 'directives', 'fields'],
  FieldDefinition: ['description', 'name', 'arguments', 'type', 'directives'],
  InputValueDefinition: ['description', 'name', 'type', 'defaultValue', 'directives'],
  InterfaceTypeDefinition: ['description', 'name', 'interfaces', 'directives', 'fields'],
  UnionTypeDefinition: ['description', 'name', 'directives', 'types'],
  EnumTypeDefinition: ['description', 'name', 'directives', 'values'],
  EnumValueDefinition: ['description', 'name', 'directives'],
  InputObjectTypeDefinition: ['description', 'name', 'directives', 'fields'],
  DirectiveDefinition: ['description', 'name', 'arguments', 'locations'],
  SchemaExtension: ['directives', 'operationTypes'],
  ScalarTypeExtension: ['name', 'directives'],
  ObjectTypeExtension: ['name', 'interfaces', 'directives', 'fields'],
  InterfaceTypeExtension: ['name', 'interfaces', 'directives', 'fields'],
  UnionTypeExtension: ['name', 'directives', 'types'],
  EnumTypeExtension: ['name', 'directives', 'values'],
  InputObjectTypeExtension: ['name', 'directives', 'fields']
};
var BREAK = Object.freeze({});
/**
 * visit() will walk through an AST using a depth-first traversal, calling
 * the visitor's enter function at each node in the traversal, and calling the
 * leave function after visiting that node and all of its child nodes.
 *
 * By returning different values from the enter and leave functions, the
 * behavior of the visitor can be altered, including skipping over a sub-tree of
 * the AST (by returning false), editing the AST by returning a value or null
 * to remove the value, or to stop the whole traversal by returning BREAK.
 *
 * When using visit() to edit an AST, the original AST will not be modified, and
 * a new version of the AST with the changes applied will be returned from the
 * visit function.
 *
 *     const editedAST = visit(ast, {
 *       enter(node, key, parent, path, ancestors) {
 *         // @return
 *         //   undefined: no action
 *         //   false: skip visiting this node
 *         //   visitor.BREAK: stop visiting altogether
 *         //   null: delete this node
 *         //   any value: replace this node with the returned value
 *       },
 *       leave(node, key, parent, path, ancestors) {
 *         // @return
 *         //   undefined: no action
 *         //   false: no action
 *         //   visitor.BREAK: stop visiting altogether
 *         //   null: delete this node
 *         //   any value: replace this node with the returned value
 *       }
 *     });
 *
 * Alternatively to providing enter() and leave() functions, a visitor can
 * instead provide functions named the same as the kinds of AST nodes, or
 * enter/leave visitors at a named key, leading to four permutations of the
 * visitor API:
 *
 * 1) Named visitors triggered when entering a node of a specific kind.
 *
 *     visit(ast, {
 *       Kind(node) {
 *         // enter the "Kind" node
 *       }
 *     })
 *
 * 2) Named visitors that trigger upon entering and leaving a node of
 *    a specific kind.
 *
 *     visit(ast, {
 *       Kind: {
 *         enter(node) {
 *           // enter the "Kind" node
 *         }
 *         leave(node) {
 *           // leave the "Kind" node
 *         }
 *       }
 *     })
 *
 * 3) Generic visitors that trigger upon entering and leaving any node.
 *
 *     visit(ast, {
 *       enter(node) {
 *         // enter any node
 *       },
 *       leave(node) {
 *         // leave any node
 *       }
 *     })
 *
 * 4) Parallel visitors for entering and leaving nodes of a specific kind.
 *
 *     visit(ast, {
 *       enter: {
 *         Kind(node) {
 *           // enter the "Kind" node
 *         }
 *       },
 *       leave: {
 *         Kind(node) {
 *           // leave the "Kind" node
 *         }
 *       }
 *     })
 */

function visit(root, visitor) {
  var visitorKeys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : QueryDocumentKeys;

  /* eslint-disable no-undef-init */
  var stack = undefined;
  var inArray = Array.isArray(root);
  var keys = [root];
  var index = -1;
  var edits = [];
  var node = undefined;
  var key = undefined;
  var parent = undefined;
  var path = [];
  var ancestors = [];
  var newRoot = root;
  /* eslint-enable no-undef-init */

  do {
    index++;
    var isLeaving = index === keys.length;
    var isEdited = isLeaving && edits.length !== 0;

    if (isLeaving) {
      key = ancestors.length === 0 ? undefined : path[path.length - 1];
      node = parent;
      parent = ancestors.pop();

      if (isEdited) {
        if (inArray) {
          node = node.slice();
        } else {
          var clone = {};

          for (var _i2 = 0, _Object$keys2 = Object.keys(node); _i2 < _Object$keys2.length; _i2++) {
            var k = _Object$keys2[_i2];
            clone[k] = node[k];
          }

          node = clone;
        }

        var editOffset = 0;

        for (var ii = 0; ii < edits.length; ii++) {
          var editKey = edits[ii][0];
          var editValue = edits[ii][1];

          if (inArray) {
            editKey -= editOffset;
          }

          if (inArray && editValue === null) {
            node.splice(editKey, 1);
            editOffset++;
          } else {
            node[editKey] = editValue;
          }
        }
      }

      index = stack.index;
      keys = stack.keys;
      edits = stack.edits;
      inArray = stack.inArray;
      stack = stack.prev;
    } else {
      key = parent ? inArray ? index : keys[index] : undefined;
      node = parent ? parent[key] : newRoot;

      if (node === null || node === undefined) {
        continue;
      }

      if (parent) {
        path.push(key);
      }
    }

    var result = void 0;

    if (!Array.isArray(node)) {
      if (!isNode(node)) {
        throw new Error("Invalid AST Node: ".concat(inspect(node), "."));
      }

      var visitFn = getVisitFn(visitor, node.kind, isLeaving);

      if (visitFn) {
        result = visitFn.call(visitor, node, key, parent, path, ancestors);

        if (result === BREAK) {
          break;
        }

        if (result === false) {
          if (!isLeaving) {
            path.pop();
            continue;
          }
        } else if (result !== undefined) {
          edits.push([key, result]);

          if (!isLeaving) {
            if (isNode(result)) {
              node = result;
            } else {
              path.pop();
              continue;
            }
          }
        }
      }
    }

    if (result === undefined && isEdited) {
      edits.push([key, node]);
    }

    if (isLeaving) {
      path.pop();
    } else {
      var _visitorKeys$node$kin;

      stack = {
        inArray: inArray,
        index: index,
        keys: keys,
        edits: edits,
        prev: stack
      };
      inArray = Array.isArray(node);
      keys = inArray ? node : (_visitorKeys$node$kin = visitorKeys[node.kind]) !== null && _visitorKeys$node$kin !== void 0 ? _visitorKeys$node$kin : [];
      index = -1;
      edits = [];

      if (parent) {
        ancestors.push(parent);
      }

      parent = node;
    }
  } while (stack !== undefined);

  if (edits.length !== 0) {
    newRoot = edits[edits.length - 1][1];
  }

  return newRoot;
}
/**
 * Creates a new visitor instance which delegates to many visitors to run in
 * parallel. Each visitor will be visited for each node before moving on.
 *
 * If a prior visitor edits a node, no following visitors will see that node.
 */

function visitInParallel(visitors) {
  var skipping = new Array(visitors.length);
  return {
    enter: function enter(node) {
      for (var i = 0; i < visitors.length; i++) {
        if (skipping[i] == null) {
          var fn = getVisitFn(visitors[i], node.kind,
          /* isLeaving */
          false);

          if (fn) {
            var result = fn.apply(visitors[i], arguments);

            if (result === false) {
              skipping[i] = node;
            } else if (result === BREAK) {
              skipping[i] = BREAK;
            } else if (result !== undefined) {
              return result;
            }
          }
        }
      }
    },
    leave: function leave(node) {
      for (var i = 0; i < visitors.length; i++) {
        if (skipping[i] == null) {
          var fn = getVisitFn(visitors[i], node.kind,
          /* isLeaving */
          true);

          if (fn) {
            var result = fn.apply(visitors[i], arguments);

            if (result === BREAK) {
              skipping[i] = BREAK;
            } else if (result !== undefined && result !== false) {
              return result;
            }
          }
        } else if (skipping[i] === node) {
          skipping[i] = null;
        }
      }
    }
  };
}
/**
 * Given a visitor instance, if it is leaving or not, and a node kind, return
 * the function the visitor runtime should call.
 */

function getVisitFn(visitor, kind, isLeaving) {
  var kindVisitor = visitor[kind];

  if (kindVisitor) {
    if (!isLeaving && typeof kindVisitor === 'function') {
      // { Kind() {} }
      return kindVisitor;
    }

    var kindSpecificVisitor = isLeaving ? kindVisitor.leave : kindVisitor.enter;

    if (typeof kindSpecificVisitor === 'function') {
      // { Kind: { enter() {}, leave() {} } }
      return kindSpecificVisitor;
    }
  } else {
    var specificVisitor = isLeaving ? visitor.leave : visitor.enter;

    if (specificVisitor) {
      if (typeof specificVisitor === 'function') {
        // { enter() {}, leave() {} }
        return specificVisitor;
      }

      var specificKindVisitor = specificVisitor[kind];

      if (typeof specificKindVisitor === 'function') {
        // { enter: { Kind() {} }, leave: { Kind() {} } }
        return specificKindVisitor;
      }
    }
  }
}

;// CONCATENATED MODULE: ./node_modules/@gelatonetwork/limit-orders-lib/node_modules/graphql/language/blockString.mjs
/**
 * Produces the value of a block string from its parsed raw value, similar to
 * CoffeeScript's block string, Python's docstring trim or Ruby's strip_heredoc.
 *
 * This implements the GraphQL spec's BlockStringValue() static algorithm.
 *
 * @internal
 */
function dedentBlockStringValue(rawString) {
  // Expand a block string's raw value into independent lines.
  var lines = rawString.split(/\r\n|[\n\r]/g); // Remove common indentation from all lines but first.

  var commonIndent = getBlockStringIndentation(rawString);

  if (commonIndent !== 0) {
    for (var i = 1; i < lines.length; i++) {
      lines[i] = lines[i].slice(commonIndent);
    }
  } // Remove leading and trailing blank lines.


  var startLine = 0;

  while (startLine < lines.length && isBlank(lines[startLine])) {
    ++startLine;
  }

  var endLine = lines.length;

  while (endLine > startLine && isBlank(lines[endLine - 1])) {
    --endLine;
  } // Return a string of the lines joined with U+000A.


  return lines.slice(startLine, endLine).join('\n');
}

function isBlank(str) {
  for (var i = 0; i < str.length; ++i) {
    if (str[i] !== ' ' && str[i] !== '\t') {
      return false;
    }
  }

  return true;
}
/**
 * @internal
 */


function getBlockStringIndentation(value) {
  var _commonIndent;

  var isFirstLine = true;
  var isEmptyLine = true;
  var indent = 0;
  var commonIndent = null;

  for (var i = 0; i < value.length; ++i) {
    switch (value.charCodeAt(i)) {
      case 13:
        //  \r
        if (value.charCodeAt(i + 1) === 10) {
          ++i; // skip \r\n as one symbol
        }

      // falls through

      case 10:
        //  \n
        isFirstLine = false;
        isEmptyLine = true;
        indent = 0;
        break;

      case 9: //   \t

      case 32:
        //  <space>
        ++indent;
        break;

      default:
        if (isEmptyLine && !isFirstLine && (commonIndent === null || indent < commonIndent)) {
          commonIndent = indent;
        }

        isEmptyLine = false;
    }
  }

  return (_commonIndent = commonIndent) !== null && _commonIndent !== void 0 ? _commonIndent : 0;
}
/**
 * Print a block string in the indented block form by adding a leading and
 * trailing blank line. However, if a block string starts with whitespace and is
 * a single-line, adding a leading blank line would strip that whitespace.
 *
 * @internal
 */

function printBlockString(value) {
  var indentation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var preferMultipleLines = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var isSingleLine = value.indexOf('\n') === -1;
  var hasLeadingSpace = value[0] === ' ' || value[0] === '\t';
  var hasTrailingQuote = value[value.length - 1] === '"';
  var hasTrailingSlash = value[value.length - 1] === '\\';
  var printAsMultipleLines = !isSingleLine || hasTrailingQuote || hasTrailingSlash || preferMultipleLines;
  var result = ''; // Format a multi-line block quote to account for leading space.

  if (printAsMultipleLines && !(isSingleLine && hasLeadingSpace)) {
    result += '\n' + indentation;
  }

  result += indentation ? value.replace(/\n/g, '\n' + indentation) : value;

  if (printAsMultipleLines) {
    result += '\n';
  }

  return '"""' + result.replace(/"""/g, '\\"""') + '"""';
}

;// CONCATENATED MODULE: ./node_modules/@gelatonetwork/limit-orders-lib/node_modules/graphql/language/printer.mjs


/**
 * Converts an AST into a string, using one set of reasonable
 * formatting rules.
 */

function print(ast) {
  return visit(ast, {
    leave: printDocASTReducer
  });
}
var MAX_LINE_LENGTH = 80; // TODO: provide better type coverage in future

var printDocASTReducer = {
  Name: function Name(node) {
    return node.value;
  },
  Variable: function Variable(node) {
    return '$' + node.name;
  },
  // Document
  Document: function Document(node) {
    return join(node.definitions, '\n\n') + '\n';
  },
  OperationDefinition: function OperationDefinition(node) {
    var op = node.operation;
    var name = node.name;
    var varDefs = wrap('(', join(node.variableDefinitions, ', '), ')');
    var directives = join(node.directives, ' ');
    var selectionSet = node.selectionSet; // Anonymous queries with no directives or variable definitions can use
    // the query short form.

    return !name && !directives && !varDefs && op === 'query' ? selectionSet : join([op, join([name, varDefs]), directives, selectionSet], ' ');
  },
  VariableDefinition: function VariableDefinition(_ref) {
    var variable = _ref.variable,
        type = _ref.type,
        defaultValue = _ref.defaultValue,
        directives = _ref.directives;
    return variable + ': ' + type + wrap(' = ', defaultValue) + wrap(' ', join(directives, ' '));
  },
  SelectionSet: function SelectionSet(_ref2) {
    var selections = _ref2.selections;
    return block(selections);
  },
  Field: function Field(_ref3) {
    var alias = _ref3.alias,
        name = _ref3.name,
        args = _ref3.arguments,
        directives = _ref3.directives,
        selectionSet = _ref3.selectionSet;
    var prefix = wrap('', alias, ': ') + name;
    var argsLine = prefix + wrap('(', join(args, ', '), ')');

    if (argsLine.length > MAX_LINE_LENGTH) {
      argsLine = prefix + wrap('(\n', indent(join(args, '\n')), '\n)');
    }

    return join([argsLine, join(directives, ' '), selectionSet], ' ');
  },
  Argument: function Argument(_ref4) {
    var name = _ref4.name,
        value = _ref4.value;
    return name + ': ' + value;
  },
  // Fragments
  FragmentSpread: function FragmentSpread(_ref5) {
    var name = _ref5.name,
        directives = _ref5.directives;
    return '...' + name + wrap(' ', join(directives, ' '));
  },
  InlineFragment: function InlineFragment(_ref6) {
    var typeCondition = _ref6.typeCondition,
        directives = _ref6.directives,
        selectionSet = _ref6.selectionSet;
    return join(['...', wrap('on ', typeCondition), join(directives, ' '), selectionSet], ' ');
  },
  FragmentDefinition: function FragmentDefinition(_ref7) {
    var name = _ref7.name,
        typeCondition = _ref7.typeCondition,
        variableDefinitions = _ref7.variableDefinitions,
        directives = _ref7.directives,
        selectionSet = _ref7.selectionSet;
    return (// Note: fragment variable definitions are experimental and may be changed
      // or removed in the future.
      "fragment ".concat(name).concat(wrap('(', join(variableDefinitions, ', '), ')'), " ") + "on ".concat(typeCondition, " ").concat(wrap('', join(directives, ' '), ' ')) + selectionSet
    );
  },
  // Value
  IntValue: function IntValue(_ref8) {
    var value = _ref8.value;
    return value;
  },
  FloatValue: function FloatValue(_ref9) {
    var value = _ref9.value;
    return value;
  },
  StringValue: function StringValue(_ref10, key) {
    var value = _ref10.value,
        isBlockString = _ref10.block;
    return isBlockString ? printBlockString(value, key === 'description' ? '' : '  ') : JSON.stringify(value);
  },
  BooleanValue: function BooleanValue(_ref11) {
    var value = _ref11.value;
    return value ? 'true' : 'false';
  },
  NullValue: function NullValue() {
    return 'null';
  },
  EnumValue: function EnumValue(_ref12) {
    var value = _ref12.value;
    return value;
  },
  ListValue: function ListValue(_ref13) {
    var values = _ref13.values;
    return '[' + join(values, ', ') + ']';
  },
  ObjectValue: function ObjectValue(_ref14) {
    var fields = _ref14.fields;
    return '{' + join(fields, ', ') + '}';
  },
  ObjectField: function ObjectField(_ref15) {
    var name = _ref15.name,
        value = _ref15.value;
    return name + ': ' + value;
  },
  // Directive
  Directive: function Directive(_ref16) {
    var name = _ref16.name,
        args = _ref16.arguments;
    return '@' + name + wrap('(', join(args, ', '), ')');
  },
  // Type
  NamedType: function NamedType(_ref17) {
    var name = _ref17.name;
    return name;
  },
  ListType: function ListType(_ref18) {
    var type = _ref18.type;
    return '[' + type + ']';
  },
  NonNullType: function NonNullType(_ref19) {
    var type = _ref19.type;
    return type + '!';
  },
  // Type System Definitions
  SchemaDefinition: addDescription(function (_ref20) {
    var directives = _ref20.directives,
        operationTypes = _ref20.operationTypes;
    return join(['schema', join(directives, ' '), block(operationTypes)], ' ');
  }),
  OperationTypeDefinition: function OperationTypeDefinition(_ref21) {
    var operation = _ref21.operation,
        type = _ref21.type;
    return operation + ': ' + type;
  },
  ScalarTypeDefinition: addDescription(function (_ref22) {
    var name = _ref22.name,
        directives = _ref22.directives;
    return join(['scalar', name, join(directives, ' ')], ' ');
  }),
  ObjectTypeDefinition: addDescription(function (_ref23) {
    var name = _ref23.name,
        interfaces = _ref23.interfaces,
        directives = _ref23.directives,
        fields = _ref23.fields;
    return join(['type', name, wrap('implements ', join(interfaces, ' & ')), join(directives, ' '), block(fields)], ' ');
  }),
  FieldDefinition: addDescription(function (_ref24) {
    var name = _ref24.name,
        args = _ref24.arguments,
        type = _ref24.type,
        directives = _ref24.directives;
    return name + (hasMultilineItems(args) ? wrap('(\n', indent(join(args, '\n')), '\n)') : wrap('(', join(args, ', '), ')')) + ': ' + type + wrap(' ', join(directives, ' '));
  }),
  InputValueDefinition: addDescription(function (_ref25) {
    var name = _ref25.name,
        type = _ref25.type,
        defaultValue = _ref25.defaultValue,
        directives = _ref25.directives;
    return join([name + ': ' + type, wrap('= ', defaultValue), join(directives, ' ')], ' ');
  }),
  InterfaceTypeDefinition: addDescription(function (_ref26) {
    var name = _ref26.name,
        interfaces = _ref26.interfaces,
        directives = _ref26.directives,
        fields = _ref26.fields;
    return join(['interface', name, wrap('implements ', join(interfaces, ' & ')), join(directives, ' '), block(fields)], ' ');
  }),
  UnionTypeDefinition: addDescription(function (_ref27) {
    var name = _ref27.name,
        directives = _ref27.directives,
        types = _ref27.types;
    return join(['union', name, join(directives, ' '), types && types.length !== 0 ? '= ' + join(types, ' | ') : ''], ' ');
  }),
  EnumTypeDefinition: addDescription(function (_ref28) {
    var name = _ref28.name,
        directives = _ref28.directives,
        values = _ref28.values;
    return join(['enum', name, join(directives, ' '), block(values)], ' ');
  }),
  EnumValueDefinition: addDescription(function (_ref29) {
    var name = _ref29.name,
        directives = _ref29.directives;
    return join([name, join(directives, ' ')], ' ');
  }),
  InputObjectTypeDefinition: addDescription(function (_ref30) {
    var name = _ref30.name,
        directives = _ref30.directives,
        fields = _ref30.fields;
    return join(['input', name, join(directives, ' '), block(fields)], ' ');
  }),
  DirectiveDefinition: addDescription(function (_ref31) {
    var name = _ref31.name,
        args = _ref31.arguments,
        repeatable = _ref31.repeatable,
        locations = _ref31.locations;
    return 'directive @' + name + (hasMultilineItems(args) ? wrap('(\n', indent(join(args, '\n')), '\n)') : wrap('(', join(args, ', '), ')')) + (repeatable ? ' repeatable' : '') + ' on ' + join(locations, ' | ');
  }),
  SchemaExtension: function SchemaExtension(_ref32) {
    var directives = _ref32.directives,
        operationTypes = _ref32.operationTypes;
    return join(['extend schema', join(directives, ' '), block(operationTypes)], ' ');
  },
  ScalarTypeExtension: function ScalarTypeExtension(_ref33) {
    var name = _ref33.name,
        directives = _ref33.directives;
    return join(['extend scalar', name, join(directives, ' ')], ' ');
  },
  ObjectTypeExtension: function ObjectTypeExtension(_ref34) {
    var name = _ref34.name,
        interfaces = _ref34.interfaces,
        directives = _ref34.directives,
        fields = _ref34.fields;
    return join(['extend type', name, wrap('implements ', join(interfaces, ' & ')), join(directives, ' '), block(fields)], ' ');
  },
  InterfaceTypeExtension: function InterfaceTypeExtension(_ref35) {
    var name = _ref35.name,
        interfaces = _ref35.interfaces,
        directives = _ref35.directives,
        fields = _ref35.fields;
    return join(['extend interface', name, wrap('implements ', join(interfaces, ' & ')), join(directives, ' '), block(fields)], ' ');
  },
  UnionTypeExtension: function UnionTypeExtension(_ref36) {
    var name = _ref36.name,
        directives = _ref36.directives,
        types = _ref36.types;
    return join(['extend union', name, join(directives, ' '), types && types.length !== 0 ? '= ' + join(types, ' | ') : ''], ' ');
  },
  EnumTypeExtension: function EnumTypeExtension(_ref37) {
    var name = _ref37.name,
        directives = _ref37.directives,
        values = _ref37.values;
    return join(['extend enum', name, join(directives, ' '), block(values)], ' ');
  },
  InputObjectTypeExtension: function InputObjectTypeExtension(_ref38) {
    var name = _ref38.name,
        directives = _ref38.directives,
        fields = _ref38.fields;
    return join(['extend input', name, join(directives, ' '), block(fields)], ' ');
  }
};

function addDescription(cb) {
  return function (node) {
    return join([node.description, cb(node)], '\n');
  };
}
/**
 * Given maybeArray, print an empty string if it is null or empty, otherwise
 * print all items together separated by separator if provided
 */


function join(maybeArray) {
  var _maybeArray$filter$jo;

  var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return (_maybeArray$filter$jo = maybeArray === null || maybeArray === void 0 ? void 0 : maybeArray.filter(function (x) {
    return x;
  }).join(separator)) !== null && _maybeArray$filter$jo !== void 0 ? _maybeArray$filter$jo : '';
}
/**
 * Given array, print each item on its own line, wrapped in an
 * indented "{ }" block.
 */


function block(array) {
  return wrap('{\n', indent(join(array, '\n')), '\n}');
}
/**
 * If maybeString is not null or empty, then wrap with start and end, otherwise print an empty string.
 */


function wrap(start, maybeString) {
  var end = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  return maybeString != null && maybeString !== '' ? start + maybeString + end : '';
}

function indent(str) {
  return wrap('  ', str.replace(/\n/g, '\n  '));
}

function isMultiline(str) {
  return str.indexOf('\n') !== -1;
}

function hasMultilineItems(maybeArray) {
  return maybeArray != null && maybeArray.some(isMultiline);
}


/***/ })

}]);